<template>
  <div class="mt-1 pb-5">
    <b-modal
      ref='alert'
      scrollable
      hide-footer
      title='Atenção'
      header-bg-variant='info'
      header-text-variant='light'
    >
      <section class='modal-font-family'>
        <p>
          A impressão do arquivo em Excel esta sendo processada,
          clique no botão abaixo para acessar a página de downloads.
        </p>
        <router-link class='float-right router-link-text-decoration' :to="{ name: 'RelatoriosConsultaLegal' }">
          <base-button class='btn_export_modal'>
            <span class="label">Acessar</span>
          </base-button>
        </router-link>
      </section>
    </b-modal>

    <LtcatModal
      :agent="selectedAgent"
      @save="saveSelectedActivitiesLtcat"
      :loading="loadingLtcatModal"
    />

    <LtcatLegalInterpretationModal :agent="selectedAgent" @save="saveInterpretationLtcat" />

    <InsalubrityModal
      :agent="selectedAgent"
      @save="saveSelectedActivities"
      :loading="loadingLtcatModal"
    />

    <ProductAdd @clear-items-remove='load'></ProductAdd>

    <OrientationVideos
      :orientationVideos="orientationVideos"
      :agent="agent"
      @clear="orientationVideos = []"
    />

    <TabButtons></TabButtons>

    <modal-confirm-action
      variant='danger'
      refModal='archiveRole'
      idModal='archiveRole'
      :loading='loadingArchive'
      :description='descriptionArchive'
      :title='titleArchive'
      @confirmed='archiveRole'
    />

    <ArchivedRoles
      :sectorId='archivedRolesSectorId'
      :tab='tabName'
      @update='reloadHierarchies'
    >
    </ArchivedRoles>

    <RoleLinkedModal
      :sectorsRoles="sectorsRoles"
      :role="role"
      @setSelected='setSelected'
    >
    </RoleLinkedModal>

    <EffectiveProtection
      :protecaoEficazProps='protecaoEficazProps'
      :questionsProps="questions"
      :disabled='disabledAnalysisTool'
      :sectorId='sectorId'
      :sectorRoleId='sectorRoleId'
      @updateEffectiveprotection='updateEffectiveprotection'
      @to-load='getSectorsByCompanyLegalConsultation'
    ></EffectiveProtection>

    <PermanentExhibition
      :disabled='disabledAnalysisTool'
      :productHierarchyId='productHierarchyId'
      :exposicaoPermanenteProps='exposicaoPermanenteProps'
      @updatePermanentExhibition='updatePermanentExhibition'
      @to-load='getSectorsByCompanyLegalConsultation'
    ></PermanentExhibition>

    <VentilationIdentifiedModal
      :sectorId='sectorId'
      @update='reloadHierarchies'
    >
    </VentilationIdentifiedModal>

    <Measurements
      :sectorRoleId='sectorRoleId'
      :legalSearches='legalSearches'
      @update='reloadHierarchies'
    ></Measurements>

    <MeasurementsByRole
      :sectorRoleIds='sectorRoleIds'
      :legalSearches='legalSearches'
      :roleId='roleId'
      @update='load'
    ></MeasurementsByRole>

    <EditTermsOfUsePerProduct
      :productLegalConsultationId='productLegalConsultationId'
      :productHierarchyIds='productHierarchyIds'
      @update='load'
    ></EditTermsOfUsePerProduct>

    <TemperatureModal
      :productId='productId'
      :termsOfUseId='termsOfUseId'
      :productHierarchyId='productHierarchyId'
      @update='reloadHierarchies'
    >
    </TemperatureModal>

    <QuantityUsedFrequencyExposureTimeUseModal
      :productId='productId'
      :productHierarchyId='productHierarchyId'
      :termsOfUseId='termsOfUseId'
      @update='reloadHierarchies'
    ></QuantityUsedFrequencyExposureTimeUseModal>

    <BindAgentToRolesModal
      ref="bindAgentToRolesModal"
      :agent="agentToBind"
      @reset="reset"
      @reload="reload"
    ></BindAgentToRolesModal>

    <Role
      ref="role"
      :roleId="null"
      :sectorId="null"
      :legalSearchId="legalSearchId"
      @update="onRoleCreated"
    />

    <b-modal
      id="add-agents-to-role"
      ref="add-agents-to-role"
      header-bg-variant="info"
      header-text-variant="light"
      title="Como deseja prosseguir?"
      size="xl"
    >
      <section class="modal-font-family text-center m-0 p-0">
        <h6><strong>Você pode vincular o agente a um cargo já existente ou cadastrar um novo cargo para associar os agentes selecionados.</strong></h6>
      </section>
      <template #modal-footer>
        <b-container fluid class="w-100 modal-font-family">
          <b-row cols="12">
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-button variant="success" class="w-100 mr-1" @click="chooseAddToExistingRole()">
                Vincular agente a um cargo cadastrado
              </b-button>
            </b-col>
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-button variant="success" class="w-100" @click="chooseRegisterNewRole()">
                Cadastrar cargo
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <ProductLinkedModal
      :productsHierarchy="productsHierarchy"
      :productLegalConsultation="productLegalConsultation"
      @setSelected='setSelectedProductHierarchy'
    >
    </ProductLinkedModal>

    <EditTemperaturePerProduct
      :productLegalConsultationId='productLegalConsultationId'
      :productHierarchyIds='productHierarchyIds'
      @update='load'
    ></EditTemperaturePerProduct>

    <AgentPercentage
      :productId='productId'
      :productHierarchyIds='productHierarchyIds'
      @update-agents='reloadHierarchies'
    >
    </AgentPercentage>

    <b-overlay
      :show='loading'
      rounded
      no-center
      opacity='0.6'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
    >
      <section v-if='sectors && sectors.length > 0' class='w-100 my-3'>
        <section v-for='sector in sectors' :key='sector._id'>
          <section :id='sector._id'>
            <section
              class='sector d-flex align-items-center justify-content-between'
            >
              <section class="ml-3">
                <span class='name'>Setor - {{ sector.name }}</span>
              </section>

              <section class='d-flex align-items-center justify-content-between mr-3'>
                <section class='d-flex align-items-center justify-content-end mr-2'>
                  <b-popover
                    :target='`${sector._id}_effectiveProtection`'
                    placement='top'
                    triggers='hover'
                  >
                    <span class='label'>
                      Clique para cadastrar/editar a proteção eficaz
                    </span>
                  </b-popover>
                  <button
                    class="mr-2"
                    :id='`${sector._id}_effectiveProtection`'
                    :class="sector.effectiveProtection &&
                      sector.effectiveProtection._id &&
                      analysisPermanentExposureAndEffectiveProtection.interactedEffectiveProtectionQuestionsPergunta_1_existeEquipamentoProtecaoColetivaAuxiliarControleRiscoQuimico(sector.effectiveProtection)
                        ? 'btn-sector-effectiveProtection-information-filled-in'
                        : 'btn-sector-effectiveProtection-information-not-filled-in'"
                    @click="showEffectiveProtection(sector._id, null, $event, ['pergunta_1_existeEquipamentoProtecaoColetivaAuxiliarControleRiscoQuimico'])"
                  >
                    <svg width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.7902 1.4375C11.9703 1.4375 10.2251 2.16042 8.93824 3.44724C7.65143 4.73405 6.92851 6.47934 6.92851 8.29917V10.1296C6.92851 9.52213 6.68719 8.93955 6.25766 8.51001C5.82812 8.08048 5.24555 7.83917 4.63809 7.83917C4.03063 7.83917 3.44806 8.08048 3.01852 8.51001C2.58898 8.93955 2.34767 9.52213 2.34767 10.1296C2.34559 11.1451 2.5453 12.151 2.9352 13.0887C3.3251 14.0265 3.89742 14.8774 4.61892 15.5921L6.92851 17.9017H20.6518V8.31833C20.6531 7.41599 20.4766 6.52223 20.1325 5.68809C19.7883 4.85395 19.2832 4.09576 18.6461 3.45682C18.0089 2.81787 17.2521 2.31068 16.419 1.96421C15.5858 1.61773 14.6925 1.43876 13.7902 1.4375Z" stroke="#022245" stroke-width="1.5" stroke-miterlimit="10"/>
                      <path d="M6.92682 17.9016H20.6502V20.6424C20.6502 20.8966 20.5492 21.1404 20.3695 21.3201C20.1897 21.4998 19.946 21.6008 19.6918 21.6008H7.83724C7.58307 21.6008 7.33932 21.4998 7.1596 21.3201C6.97987 21.1404 6.87891 20.8966 6.87891 20.6424V17.9016H6.92682Z" stroke="#022245" stroke-width="1.5" stroke-miterlimit="10"/>
                      <path d="M6.92969 12.4104V9.66956" stroke="#022245" stroke-width="1.5" stroke-miterlimit="10"/>
                    </svg>
                  </button>

                  <b-popover
                    :target='`${sector._id}_ventilationWorkEnvironmentGeneral`'
                    placement='top'
                    triggers='hover'
                  >
                    <span class='label'>
                      Clique para cadastrar/editar a condição de ventilação do ambiente de trabalho de forma geral
                    </span>
                  </b-popover>
                  <button
                    :id='`${sector._id}_ventilationWorkEnvironmentGeneral`'
                    :class="sector && sector._id && sector.ventilationWorkEnvironmentGeneral
                      ? 'btn-information-filled-in'
                      : 'btn-information-not-filled-in'"
                    @click='showModalCentilationWorkEnvironmentGeneral(sector, $event)'
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.3018 0C21.7319 0 23.7089 1.97705 23.709 4.40723V19.3018C23.709 21.7318 21.7325 23.7088 19.3027 23.709H4.40723C1.97705 23.7088 0.000220658 21.7324 0 19.3027V4.40723C4.46801e-05 1.97708 1.97708 4.46796e-05 4.40723 0H19.3018ZM11.7031 2C6.34434 2 2 6.34434 2 11.7031C2.00011 17.0618 6.34441 21.4062 11.7031 21.4062C17.0618 21.4061 21.4061 17.0618 21.4062 11.7031C21.4062 6.34441 17.0618 2.00011 11.7031 2ZM2.98438 19.9004C2.71257 19.9006 2.49229 20.1207 2.49219 20.3926C2.49219 20.6645 2.71251 20.8855 2.98438 20.8857C3.25645 20.8857 3.47754 20.6646 3.47754 20.3926C3.47743 20.1206 3.25638 19.9004 2.98438 19.9004ZM20.7188 19.9004C20.4469 19.9006 20.2267 20.1207 20.2266 20.3926C20.2266 20.6645 20.4469 20.8855 20.7188 20.8857C20.9908 20.8857 21.2119 20.6646 21.2119 20.3926C21.2118 20.1206 20.9908 19.9004 20.7188 19.9004ZM2.98438 2.49512C2.71257 2.49536 2.49229 2.71547 2.49219 2.9873C2.49219 3.25923 2.71251 3.48023 2.98438 3.48047C3.25645 3.48047 3.47754 3.25938 3.47754 2.9873C3.47743 2.71532 3.25638 2.49512 2.98438 2.49512ZM20.7188 2.49512C20.4469 2.49536 20.2267 2.71547 20.2266 2.9873C20.2266 3.25923 20.4469 3.48023 20.7188 3.48047C20.9908 3.48047 21.2119 3.25938 21.2119 2.9873C21.2118 2.71532 20.9908 2.49512 20.7188 2.49512Z" fill="#022245"/>
                      <path d="M11.8574 2.85352C13.1491 2.85352 14.3951 3.12403 15.5605 3.65723C15.7581 3.74765 15.8453 3.98172 15.7549 4.17969L13.4971 9.12207C14.3438 9.64842 14.8938 10.5572 14.9609 11.5566L20.373 12.0742C20.5897 12.095 20.7489 12.2875 20.7285 12.5039C20.6076 13.7787 20.2184 14.9926 19.5732 16.1104C18.9274 17.2287 18.0707 18.1725 17.0264 18.915C16.8488 19.0415 16.6025 18.9996 16.4766 18.8223L13.3799 14.4736C12.916 14.7365 12.3967 14.874 11.8574 14.874C11.3406 14.874 10.8401 14.7477 10.3896 14.5049L7.23828 18.9307C7.16142 19.0386 7.04018 19.0966 6.91699 19.0967C6.83796 19.0967 6.75776 19.0727 6.68848 19.0234C5.64407 18.2809 4.78751 17.3372 4.1416 16.2188C3.49644 15.1012 3.10777 13.8873 2.98633 12.6123C2.96604 12.3958 3.12427 12.2035 3.34082 12.1826L8.74805 11.665C8.78129 10.6227 9.34102 9.66736 10.2188 9.12207L7.96289 4.17871C7.87241 3.98065 7.95918 3.74684 8.15723 3.65625C9.32182 3.12364 10.5669 2.85352 11.8574 2.85352ZM11.8906 9C10.2943 9 9 10.2943 9 11.8906C9.0001 13.4869 10.2943 14.7812 11.8906 14.7812C13.4867 14.781 14.7811 13.4868 14.7812 11.8906C14.7812 10.2944 13.4868 9.00021 11.8906 9Z" fill="#022245"/>
                    </svg>
                  </button>

                  <!--Ver cargos arquivados-->
                  <b-popover
                    :target='`${sector._id}_archivedRoles`'
                    placement='top'
                    triggers='hover'
                  >
                    <span class='label'>
                      Clique para ver os cargos arquivados do setor
                    </span>
                  </b-popover>
                  <button
                    :id='`${sector._id}_archivedRoles`'
                    class='btn-information-filled-in ml-2'
                    @click='showModalArchivedRoles(sector, $event)'
                  >
                    <svg
                      width='19'
                      height='19'
                      viewBox='0 0 16 16'
                      class='bi bi-archive'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path d='M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z' />
                    </svg>
                  </button>
                </section>

                <section>
                  <button
                    class='btn-expand-collapse-navy-blue'
                    @click="toggleSectorOpen(sector._id)"
                    :class="sector.open ? '' : 'pulse-global'"
                  >
                    {{ sector.open ? 'Recolher informações' : 'Expandir informações' }}
                  </button>
                </section>
              </section>
            </section>

            <section
              v-show="sector.open"
              v-for='sectorRole in sector.sectorsRoles'
              :key='sectorRole._id'
              class='margin-left-25 margin-top-1'
            >
              <section :id="sectorRole._id" v-if="sectorRole && sectorRole.role">
                <section class='cargo-header d-flex align-items-center justify-content-between'>
                  <section class="ml-3">
                    <span class='cargo-name '>Cargo - {{ sectorRole.role.name }}</span>
                  </section>

                  <section class=" d-flex align-items-center justify-content-between">
                    <b-popover
                      :target='`${sectorRole._id}_effectiveProtection`'
                      placement='top'
                      triggers='hover'
                    >
                      <span class='label'>
                        Clique para cadastrar/editar a proteção eficaz
                      </span>
                    </b-popover>
                    <button
                      :id='`${sectorRole._id}_effectiveProtection`'
                      class="d-flex align-items-center justify-content-center mr-2"
                      :class="sectorRole && sectorRole.effectiveProtection &&
                        sectorRole.effectiveProtection._id &&
                        analysisPermanentExposureAndEffectiveProtection.interactedEffectiveProtectionQuestionsPergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06TopicoPergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66(sectorRole.effectiveProtection)
                          ? 'btn-information-filled-in'
                          : 'btn-information-not-filled-in'"
                      @click="showEffectiveProtection(null, sectorRole._id, $event, ['pergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06Topico', 'pergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66'])"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 25" class="bi bi-speedometer"  xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M13.4805 0.568359C13.7644 0.568359 13.9941 0.798705 13.9941 1.08203V5.06641C13.9941 5.34973 13.7644 5.58008 13.4805 5.58008H12.6104C12.0868 9.94847 12.61 12.7799 14.167 14.5576C15.563 16.1512 17.8732 16.957 21.3096 16.957C21.3107 16.957 21.3169 16.9577 21.3252 16.958H21.3262C22.0517 16.9808 22.6786 17.3568 23.1387 18.0078C23.6352 18.7107 23.9155 19.7037 24.0303 20.7109C24.0457 20.7431 24.0624 20.7784 24.0713 20.8193L24.0811 20.8936L24.0898 21.2109C24.0912 21.3218 24.0909 21.4373 24.0889 21.5557C24.1089 22.3889 24.0219 23.2072 23.835 23.875L23.834 23.874C23.8188 23.9337 23.8034 23.9924 23.7861 24.0469V24.0479C23.7182 24.2605 23.5204 24.4043 23.2969 24.4043H13.2666C13.0874 24.4042 12.9214 24.3113 12.8281 24.1582V24.1572C12.5191 23.647 11.9823 23.3448 11.3906 23.3447H8.08691C7.49535 23.3447 6.95875 23.6471 6.64941 24.1572V24.1582C6.55645 24.3111 6.38957 24.4043 6.20996 24.4043H1.32031C1.08797 24.4043 0.884383 24.2488 0.824219 24.0244C-0.0391866 20.7962 0.265884 18.0928 0.641602 14.7324C0.925662 12.1903 1.24274 9.33343 1.14746 5.58008H0.396484C0.112996 5.58008 -0.117188 5.34989 -0.117188 5.06641V1.08203C-0.117188 0.798543 0.112996 0.568359 0.396484 0.568359H13.4805ZM1.50586 21.4336C1.54708 22.0741 1.62109 22.8067 1.73145 23.3779H5.94043C6.45125 22.7097 7.23432 22.3174 8.08691 22.3174H11.3906C12.2428 22.3175 13.0258 22.7099 13.5361 23.3779H22.8936C22.9901 22.8758 23.0516 22.1635 23.0625 21.5439C23.0614 21.5071 23.0591 21.4704 23.0576 21.4336H1.50586ZM2.17578 5.58008C2.27098 9.3937 1.94801 12.2898 1.66211 14.8467C1.43348 16.8899 1.24199 18.6465 1.31543 20.4062H22.9521C22.8299 19.6851 22.6117 19.0422 22.2998 18.6006C22.0074 18.1866 21.6702 17.9972 21.2969 17.9844V17.9834C17.6403 17.9812 15.0307 17.102 13.3945 15.2344C11.6046 13.1905 11.0507 10.0847 11.5742 5.58008H2.17578ZM0.910156 4.55371H12.9668V1.5957H0.910156V4.55371Z"/>
                      </svg>
                    </button>

                    <b-popover
                      custom-class=''
                      :target='`${sectorRole._id}_measurement`'
                      placement='top'
                      triggers='hover'
                    >
                      <span class='label'>
                        Clique para cadastrar/editar medições
                      </span>
                    </b-popover>
                    <button
                      :id='`${sectorRole._id}_measurement`'
                      class="d-flex align-items-center justify-content-center mr-2"
                      :class="sectorRole && (sectorRole.measurements && sectorRole.measurements.length > 0 || sectorRole.noMeasurementsWillBeTaken)
                        ? 'btn-information-filled-in'
                        : 'btn-information-not-filled-in'"
                      @click="showModalEditMeasurements(sectorRole, $event)"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" class="bi bi-speedometer" viewBox="0 0 16 16">
                        <path d="M8 2a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V2.5A.5.5 0 0 1 8 2M3.732 3.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707M2 8a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8m9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5m.754-4.246a.39.39 0 0 0-.527-.02L7.547 7.31A.91.91 0 1 0 8.85 8.569l3.434-4.297a.39.39 0 0 0-.029-.518z"/>
                        <path fill-rule="evenodd" d="M6.664 15.889A8 8 0 1 1 9.336.11a8 8 0 0 1-2.672 15.78zm-4.665-4.283A11.95 11.95 0 0 1 8 10c2.186 0 4.236.585 6.001 1.606a7 7 0 1 0-12.002 0"/>
                      </svg>
                    </button>

                    <!--Arquivar cargo-->
                    <b-popover
                      :target='`${sectorRole._id}_archiveRole`'
                      placement='top'
                      triggers='hover'
                    >
                      <span class='label'>
                        Clique para arquivar o cargo e as informações dele neste setor
                      </span>
                    </b-popover>
                    <button
                      :id='`${sectorRole._id}_archiveRole`'
                      class='btn-information-filled-in d-flex align-items-center justify-content-center mr-2'
                      @click='showModalArchiveRole(sectorRole, sector, $event)'
                    >
                      <svg
                        width='19'
                        height='19'
                        viewBox='0 0 16 16'
                        class='bi bi-archive'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path d='M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z' />
                      </svg>
                    </button>

                    <section>
                      <button
                        class='btn-expand-collapse-navy-blue mr-3'
                        @click='toggleSectorRoleOpen(sectorRole._id)'
                        :class="sectorRole.open ? '' : 'pulse-global'"
                      >
                        {{ sectorRole.open ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>
                  </section>
                </section>

                <section v-if='sectorRole && sectorRole.open' class="margin-left-25">
                  <!-- ===== RISCOS QUÍMICOS ===== -->
                  <section
                    v-if="sectorRole.role && sectorRole.role.rolesProductsLegalConsultation && sectorRole.role.rolesProductsLegalConsultation.length > 0"
                    class="margin-top-2"
                  >
                    <section class='risk-chemical d-flex align-items-center justify-content-between py-2'>
                      <section class="ml-3">
                        <strong class='risk-text'>Riscos Químicos</strong>
                      </section>

                      <section class="mr-3">
                        <button
                          class='btn-expand-collapse-navy-blue'
                          @click="toggleRiskOpen(sectorRole, 'chemicalRiskOpen')"
                          :class="sectorRole.chemicalRiskOpen ? '' : 'pulse-global'"
                        >
                          {{ sectorRole.chemicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                        </button>
                      </section>
                    </section>

                    <section class="margin-left-25 margin-top-2">
                      <section
                        v-for='roleProductLegalConsultation in sectorRole.role.rolesProductsLegalConsultation'
                        :key='roleProductLegalConsultation._id'
                        v-show="sectorRole.chemicalRiskOpen"
                      >
                        <section
                          v-if='roleProductLegalConsultation && roleProductLegalConsultation.product'
                          :id='roleProductLegalConsultation._id'
                          class='product'
                        >
                          <section
                            class='product d-flex align-items-center justify-content-between'
                            style='background: #DADADA'
                          >
                            <section class='d-flex align-items-center justify-content-start h-100 ml-3'>
                              <span class='name'>
                                Produto: {{ roleProductLegalConsultation.product.name }}
                              </span>
                            </section>

                            <section class='d-flex align-items-center justify-content-between mr-3'>
                              <!--Exposição Permanente-->
                              <b-popover
                                custom-class=''
                                :target='`${roleProductLegalConsultation.product._id}_permanentExhibition`'
                                placement='top'
                                triggers='hover'
                              >
                                <span
                                  class='label'
                                  v-if='roleProductLegalConsultation.product.permanentExhibition && roleProductLegalConsultation.product.permanentExhibition._id'
                                >
                                  Clique para editar a exposição permanente
                                </span>
                                <span v-else class='label'>
                                  Clique para cadastrar a exposição permanente
                                </span>
                              </b-popover>
                              <button
                                :id='`${roleProductLegalConsultation.product._id}_permanentExhibition`'
                                class="d-flex align-items-center justify-content-center mr-2"
                                :class="roleProductLegalConsultation.product.permanentExhibition &&
                                    roleProductLegalConsultation.product.permanentExhibition._id &&
                                    analysisPermanentExposureAndEffectiveProtection.interactedPermanentExposureQuestions(roleProductLegalConsultation.product.permanentExhibition)
                                      ? 'btn-completed-permanent-exhibition'
                                      : 'btn-permanent-exhibition-without-filling'"
                                @click="showPermanentExhibition(roleProductLegalConsultation.product, sector, $event)"
                              >
                                <p class='image-permanent-exhibition'></p>
                              </button>

                              <b-popover
                                custom-class=''
                                :target='`${roleProductLegalConsultation.product}_frequencyUse`'
                                placement='top'
                                triggers='hover'
                              >
                                <span class='label'>
                                  Clique para cadastrar/editar a quantidade diária utilizada deste produto, frequência de <br/>
                                  utilização deste produto e tempo de exposição do trabalhador com o uso do produto
                                </span>
                              </b-popover>
                              <button
                                :id='`${roleProductLegalConsultation.product}_frequencyUse`'
                                class="d-flex align-items-center justify-content-center mr-2"
                                :class="roleProductLegalConsultation.product && roleProductLegalConsultation.product.termsofuses && roleProductLegalConsultation.product.termsofuses._id
                                    ? 'btn-information-filled-in'
                                    : 'btn-information-not-filled-in'"
                                @click="showWorkersModal(roleProductLegalConsultation.product, 'quantityUsedFrequencyExposureTimeUseModal')"
                              >
                                <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='none'>
                                  <path d='M22.1492 9.65625H16.1492C16.0461 9.65625 15.9617 9.74062 15.9617 9.84375V10.9688C15.9617 11.0719 16.0461 11.1562 16.1492 11.1562H22.1492C22.2523 11.1562 22.3367 11.0719 22.3367 10.9688V9.84375C22.3367 9.74062 22.2523 9.65625 22.1492 9.65625ZM19.0086 12.8438H16.1492C16.0461 12.8438 15.9617 12.9281 15.9617 13.0312V14.1562C15.9617 14.2594 16.0461 14.3438 16.1492 14.3438H19.0086C19.1117 14.3438 19.1961 14.2594 19.1961 14.1562V13.0312C19.1961 12.9281 19.1117 12.8438 19.0086 12.8438ZM11.1875 7.55859H10.1727C10.0273 7.55859 9.91016 7.67578 9.91016 7.82109V13.6336C9.91016 13.718 9.95 13.7953 10.018 13.8445L13.5078 16.3898C13.625 16.4742 13.7891 16.4508 13.8734 16.3336L14.4758 15.5109V15.5086C14.5602 15.3914 14.5344 15.2273 14.4172 15.143L11.4477 12.9961V7.82109C11.45 7.67578 11.3305 7.55859 11.1875 7.55859Z' fill='#022245' />
                                  <path d='M18.8625 15.7945H17.5078C17.3766 15.7945 17.2524 15.8625 17.182 15.975C16.8844 16.4461 16.5375 16.882 16.1391 17.2804C15.4524 17.9671 14.6531 18.5062 13.7649 18.8812C12.8438 19.2703 11.8664 19.4671 10.8586 19.4671C9.84845 19.4671 8.87111 19.2703 7.95236 18.8812C7.06408 18.5062 6.26486 17.9671 5.57814 17.2804C4.89142 16.5937 4.35236 15.7945 3.97736 14.9062C3.5883 13.9875 3.39142 13.0101 3.39142 12C3.39142 10.9898 3.5883 10.0148 3.97736 9.09371C4.35236 8.20543 4.89142 7.40621 5.57814 6.71949C6.26486 6.03277 7.06408 5.49371 7.95236 5.11871C8.87111 4.72965 9.8508 4.53277 10.8586 4.53277C11.8688 4.53277 12.8461 4.72965 13.7649 5.11871C14.6531 5.49371 15.4524 6.03277 16.1391 6.71949C16.5375 7.11793 16.8844 7.55386 17.182 8.02496C17.2524 8.13746 17.3766 8.20543 17.5078 8.20543H18.8625C19.0242 8.20543 19.1274 8.03668 19.0547 7.89371C17.5266 4.85386 14.4281 2.87808 10.9688 2.83824C5.90392 2.77496 1.69689 6.92105 1.68752 11.9812C1.67814 17.0507 5.78673 21.164 10.8563 21.164C14.3602 21.164 17.5102 19.1812 19.0547 16.1062C19.1274 15.9632 19.0219 15.7945 18.8625 15.7945Z' fill='#022245' />
                                </svg>
                              </button>

                              <b-popover
                                custom-class=''
                                :target='`${roleProductLegalConsultation.product}_temperature`'
                                placement='top'
                                triggers='hover'
                              >
                                <span class='label'>
                                  Clique para cadastrar/editar a temperatura (em ºC - graus Celsius) de uso do produto
                                </span>
                              </b-popover>
                              <button
                                :id='`${roleProductLegalConsultation.product}_temperature`'
                                class="d-flex align-items-center justify-content-center mr-2"
                                :class="roleProductLegalConsultation.product && roleProductLegalConsultation.product.termsofuses && roleProductLegalConsultation.product.termsofuses.temperature
                                    ? 'btn-information-filled-in'
                                    : 'btn-information-not-filled-in'"
                                @click="showWorkersModal(roleProductLegalConsultation.product, 'temperatureModal')"
                              >
                                <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='none'>
                                  <path d='M22.5 13.5H18C17.6023 13.4996 17.221 13.3414 16.9398 13.0602C16.6586 12.779 16.5004 12.3977 16.5 12V4.5C16.5004 4.1023 16.6586 3.721 16.9398 3.43978C17.221 3.15856 17.6023 3.0004 18 3H22.5V4.5H18V12H22.5V13.5Z' fill='#022245' />
                                  <path d='M13.5 4.5C14.3284 4.5 15 3.82843 15 3C15 2.17157 14.3284 1.5 13.5 1.5C12.6716 1.5 12 2.17157 12 3C12 3.82843 12.6716 4.5 13.5 4.5Z' fill='#022245' />
                                  <path d='M7.50001 15.138V9H6V15.138C5.49959 15.3149 5.07784 15.6631 4.80928 16.1209C4.54072 16.5787 4.44265 17.1167 4.53241 17.6398C4.62216 18.1629 4.89396 18.6375 5.29976 18.9796C5.70556 19.3217 6.21924 19.5093 6.75 19.5093C7.28077 19.5093 7.79445 19.3217 8.20025 18.9796C8.60605 18.6375 8.87785 18.1629 8.9676 17.6398C9.05736 17.1167 8.95929 16.5787 8.69073 16.1209C8.42217 15.6631 8.00042 15.3149 7.50001 15.138Z' fill='#022245' />
                                  <path d='M6.75065 22.5C5.71713 22.5012 4.70631 22.1969 3.84511 21.6255C2.98391 21.0541 2.31072 20.241 1.91009 19.2883C1.50945 18.3356 1.39923 17.2858 1.59325 16.2706C1.78728 15.2555 2.27691 14.3203 3.00065 13.5825V5.25C3.00065 4.25544 3.39574 3.30161 4.099 2.59835C4.80226 1.89509 5.75609 1.5 6.75065 1.5C7.74521 1.5 8.69904 1.89509 9.4023 2.59835C10.1056 3.30161 10.5007 4.25544 10.5007 5.25V13.5825C11.2244 14.3203 11.714 15.2555 11.9081 16.2706C12.1021 17.2858 11.9919 18.3356 11.5912 19.2883C11.1906 20.241 10.5174 21.0541 9.6562 21.6255C8.795 22.1969 7.78417 22.5012 6.75065 22.5ZM6.75065 3C6.1541 3.0006 5.58215 3.23784 5.16032 3.65967C4.73849 4.0815 4.50125 4.65345 4.50065 5.25V14.2373L4.25165 14.4615C3.68531 14.9677 3.28604 15.6339 3.10669 16.372C2.92734 17.1101 2.97636 17.8853 3.24727 18.5949C3.51818 19.3046 3.9982 19.9152 4.6238 20.346C5.24939 20.7768 5.99107 21.0075 6.75065 21.0075C7.51024 21.0075 8.25191 20.7768 8.87751 20.346C9.50311 19.9152 9.98313 19.3046 10.254 18.5949C10.5249 17.8853 10.574 17.1101 10.3946 16.372C10.2153 15.6339 9.81599 14.9677 9.24965 14.4615L9.00065 14.2373V5.25C9.00006 4.65345 8.76281 4.0815 8.34098 3.65967C7.91916 3.23784 7.34721 3.0006 6.75065 3Z' fill='#022245' />
                                </svg>
                              </button>

                              <b-popover
                                custom-class=''
                                :target='`${roleProductLegalConsultation.product}_percentage`'
                                placement='top'
                                triggers='hover'
                              >
                                <span class='label'>
                                  Clique para editar/cadastrar a porcentagem do produto em cada agente
                                </span>
                              </b-popover>
                              <button
                                :id='`${roleProductLegalConsultation.product}_percentage`'
                                class="d-flex align-items-center justify-content-center mr-2"
                                :class="roleProductLegalConsultation.product.legalSearches.some((x) => !x.percentage || x.percentage <= 0)
                                    ? 'btn-information-not-filled-in'
                                    : 'btn-information-filled-in'"
                                @click="showModalAgentPercentage(roleProductLegalConsultation.product)"
                              >
                                <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='none'>
                                  <path d='M18.5 3.5L3.5 18.501L5.496 20.497L20.496 5.497L18.5 3.5ZM7.001 5C6.73836 4.99974 6.47823 5.05121 6.23548 5.15148C5.99273 5.25174 5.7721 5.39884 5.5862 5.58437C5.4003 5.7699 5.25276 5.99023 5.15201 6.23279C5.05125 6.47534 4.99926 6.73536 4.999 6.998C4.99874 7.26064 5.05021 7.52077 5.15048 7.76352C5.25074 8.00627 5.39784 8.2269 5.58337 8.4128C5.7689 8.5987 5.98923 8.74624 6.23179 8.84699C6.47434 8.94775 6.73436 8.99974 6.997 9C7.52743 9.00053 8.03635 8.79033 8.4118 8.41563C8.78725 8.04093 8.99847 7.53243 8.999 7.002C8.99953 6.47157 8.78933 5.96265 8.41463 5.5872C8.03993 5.21175 7.53143 5.00053 7.001 5ZM17.001 15C16.4706 14.9995 15.9616 15.2097 15.5862 15.5844C15.2108 15.9591 14.9995 16.4676 14.999 16.998C14.9985 17.5284 15.2087 18.0374 15.5834 18.4128C15.9581 18.7882 16.4666 18.9995 16.997 19C17.2596 19.0003 17.5198 18.9488 17.7625 18.8485C18.0053 18.7483 18.2259 18.6012 18.4118 18.4156C18.5977 18.2301 18.7452 18.0098 18.846 17.7672C18.9467 17.5247 18.9987 17.2646 18.999 17.002C18.9993 16.7394 18.9478 16.4792 18.8475 16.2365C18.7473 15.9937 18.6002 15.7731 18.4146 15.5872C18.2291 15.4013 18.0088 15.2538 17.7662 15.153C17.5237 15.0523 17.2636 15.0003 17.001 15Z' fill='#022245' />
                                </svg>
                              </button>

                              <button
                                class='btn-expand-collapse-navy-blue'
                                @click="toggleProductOpen(roleProductLegalConsultation.product)"
                                :class="roleProductLegalConsultation.product.open ? '' : 'pulse-global'"
                              >
                                {{ roleProductLegalConsultation.product.open ? 'Recolher informações' : 'Expandir informações' }}
                              </button>
                            </section>
                          </section>

                          <table
                            style="margin-top: 0"
                            v-if="roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.open"
                            class="text-center table b-table table-bordered custom-table"
                          >
                            <thead class='sticky '>
                              <tr class='header-table-chemical'>
                                <th rowspan="2">CAS: Agente</th>
                                <th rowspan="2">Detalhes do Agente</th>
                                <th rowspan="2">Lista de Atividades</th>
                                <th rowspan="2">Forma de avaliação</th>
                                <th rowspan="2">Relação com a NR 15</th>
                                <th colspan="2">Decreto 3048/99 - Anexo IV</th>
                                <th rowspan="2">Informações Previdenciárias Adicionais</th>
                                <th rowspan="2">Linach</th>
                                <th rowspan="2">ESOCIAL - Tabela 24</th>
                              </tr>
                              <tr class='header-table-chemical'>
                                <th>Grupo</th>
                                <th>Código</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="(legalSearch, indexLegalSearch) in roleProductLegalConsultation.product.legalSearches_">
                                <template>
                                  <tr :key="`sr_chem_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                                      <b-tooltip
                                        :target="`sr_chem_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                                        placement="auto"
                                        triggers="hover"
                                        custom-class="custom-tooltip"
                                      >
                                        <section v-if='(legalSearch.attachment11 && legalSearch.attachment11.group) || legalSearch.nameAttachment11'>
                                          <span class='p-2 text-white' style='font-size: 15px'>
                                            Este agente consta na NR 15 com o seguinte nome:
                                            {{ legalSearch.attachment11 && legalSearch.attachment11.group ? legalSearch.attachment11.group : legalSearch.nameAttachment11 ? legalSearch.nameAttachment11 : '-' }}
                                          </span> <br/><br/>
                                        </section>
                                        <section class='p-2' v-if='legalSearch.acgih && legalSearch.agent'>
                                          <span class='text-white' style='font-size: 15px'>
                                            Este agente já foi citado na ACGIH com o nome:
                                            {{ legalSearch.agent ? legalSearch.agent : '-' }}
                                          </span>
                                          <br/><br/>
                                        </section>
                                        <a :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${legalSearch.cas}`" target='_blank' class='link-pubchem-cas ml-2'>
                                          <span>Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{ legalSearch.cas }}</span>
                                        </a>
                                      </b-tooltip>

                                      <a href="#" class='hover_links word-break' :id="`sr_chem_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                        <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                        <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                      </a>

                                      <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                                        <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                                          <span>Ver orientações <br/> especificas</span>
                                        </button>
                                      </section>
                                    </td>
                                  </tr>
                                </template>

                                <template v-if="model.getActivity(legalSearch)">
                                  <tr :key='`sr_chem_row1_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                    <template v-for="field in model.tableFields">
                                      <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                                        <template v-if="field.key === 'activities'">
                                          <a class='hover_links' href="#" v-b-tooltip.lefttop.hover.html
                                            :title="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"
                                            v-if="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"
                                            @click="displayActivities(legalSearch, model.isActivitySpecific(legalSearch))">
                                            <span class='d-flex align-items-center justify-content-center'>
                                              Selecionadas
                                              <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                            </span>
                                          </a>
                                          <a href="#" v-else>-</a>
                                        </template>

                                        <template v-else-if="field.key === 'evaluation'">
                                          <span v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"></span>
                                          <a class='hover_links' href="#" v-b-tooltip.lefttop.hover.html
                                            title="Clique aqui para selecionar a sua interpretação sobre esse agente"
                                            v-if="legalSearch.legalInterpretation"
                                            @click="displayLegalInterpretation(legalSearch)">
                                            <span class='d-flex align-items-center justify-content-center'>
                                              Interpretação jurídica
                                              <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                            </span>
                                          </a>
                                        </template>

                                        <template v-else>
                                          <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"/>
                                        </template>

                                        <template v-if="field.key === 'agentDetails'">
                                          <section>
                                            <b-tooltip :target="`sr_chem_taxonomy_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="topright" triggers="hover">
                                              <div v-if="legalSearch.taxonomy && legalSearch.taxonomy.agentDescription">
                                                <strong class='text-white mb-4'>Descrição do agente</strong>
                                                <br/>
                                                <span class='text-white mt-4'>{{ legalSearch.taxonomy.agentDescription }}</span>
                                                <br/>
                                                <taxonomy :taxonomy="legalSearch.taxonomy"/>
                                              </div>
                                              <div v-else>
                                                <span>Por hora não temos informações sobre a taxonomia e descrição deste agente químico. Estamos trabalhando constantemente na atualização e inclusão de novas informações e no futuro este agente poderá apresentar mais informações.</span>
                                              </div>
                                            </b-tooltip>
                                            <a class='hover_links' href="#" :id="`sr_chem_taxonomy_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                              <span class='d-flex align-items-center justify-content-center'>
                                                Ver descrição
                                                <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                              </span>
                                            </a>
                                          </section>
                                          <section class='mt-2'>
                                            <b-tooltip :target="`sr_chem_harmfulness_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                              <span v-html='getPhraseList(legalSearch)'></span>
                                            </b-tooltip>
                                            <a class='hover_links' href="#" :id="`sr_chem_harmfulness_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                              <span class='d-flex align-items-center justify-content-center'>
                                                Ver nocividade
                                                <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                              </span>
                                            </a>
                                          </section>
                                        </template>

                                        <template v-if="field.key === 'group'">
                                          <b-tooltip v-if="getGroupLtcat(model.getGroup(legalSearch))" :target="`sr_chem_group_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                            <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                                          </b-tooltip>
                                          <a class='hover_links' href="#" :id="`sr_chem_group_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                            <span>
                                              {{ model.getGroup(legalSearch) }}
                                              <b-icon v-if="getGroupLtcat(model.getGroup(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                            </span>
                                          </a>
                                        </template>

                                        <template v-if="field.key === 'base'">
                                          <b-tooltip v-if="getGroupUnhealthy(model.getBase(legalSearch))" :target="`sr_chem_base_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                            <span class='text-white'>{{ getGroupUnhealthy(model.getBase(legalSearch)) }}</span>
                                          </b-tooltip>
                                          <a class='hover_links' href="#" :id="`sr_chem_base_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                            <span>
                                              {{ model.getBase(legalSearch) }}
                                              <b-icon v-if="getGroupUnhealthy(model.getBase(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                            </span>
                                          </a>
                                        </template>
                                      </td>
                                    </template>
                                  </tr>

                                  <tr :key='`sr_chem_row2_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                    <td colspan='9'>
                                      <p class='title-observation'>
                                        Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                                        Ela não é uma conclusão de laudo técnico.
                                      </p>
                                      <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                                        <section class='d-flex'>
                                          <p class='observation transition'>
                                            <span class='transition' v-html="analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, exposicaoPermanente, protecaoEficaz).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, exposicaoPermanente, protecaoEficaz).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)"></span>
                                            <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                                              Clique para expandir ...
                                            </strong>
                                          </p>
                                        </section>
                                        <section class='pl-3'>
                                          <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                                        </section>
                                      </section>
                                    </td>
                                  </tr>
                                </template>

                                <template v-else>
                                  <tr v-if="model.verificarGrupoBenzenoSeusCompostosToxicos(model.getGroup(legalSearch), legalSearch)" :key="`sr_chem_row4_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <td colspan="10" class="selectable-row">
                                      <a href="#" @click="displayLegalInterpretation(legalSearch)">
                                        <span class='selectable-row-text'>Agente necessita de interpretação jurídica selecione aqui</span>
                                      </a>
                                    </td>
                                  </tr>
                                  <tr v-else :key="`sr_chem_row3_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <td colspan="10" class="selectable-row">
                                      <a href="#" @click="displayActivities(legalSearch, model.isActivitySpecific(legalSearch))">
                                        <span class='selectable-row-text'>Agente necessita de determinação de atividade, selecione aqui</span>
                                      </a>
                                    </td>
                                  </tr>
                                </template>
                              </template>
                            </tbody>
                          </table>
                        </section>
                      </section>
                    </section>
                  </section>

                  <section v-if="getRolesLegalsearches(sectorRole, 'fisico')" class="margin-top-2">
                    <section class='risk-physical d-flex align-items-center justify-content-between py-2'>
                      <strong class='risk-text ml-3'>Riscos Físicos</strong>
                      <button
                        class='btn-expand-collapse-navy-blue mr-3'
                        :class="sectorRole.physicalRiskOpen ? '' : 'pulse-global'"
                        @click="toggleRiskOpen(sectorRole, 'physicalRiskOpen')"
                      >
                        {{ sectorRole.physicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>
                    <section v-if="sectorRole.physicalRiskOpen" class='transition margin-left-25'>
                      <table class="text-center table b-table table-bordered custom-table margin-top-1">
                        <thead class='sticky'>
                          <tr class='header-table-physical'>
                            <th rowspan="2">CAS: Agente</th>
                            <th rowspan="2">Detalhes do agente</th>
                            <th rowspan="2">Limites de tolerância</th>
                            <th rowspan="2">Forma de avaliação</th>
                            <th rowspan="2">Relação com a NR 15</th>
                            <th colspan="2">Decreto 3048/99 - Anexo IV</th>
                            <th rowspan="2">Informações Previdenciárias Adicionais</th>
                            <th rowspan="2">ESOCIAL - Tabela 24</th>
                          </tr>
                          <tr class='header-table-physical'>
                            <th>Grupo</th>
                            <th>Código</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(legalSearch, indexLegalSearch) in getAgentsByRisk(sectorRole, 'fisico')">
                            <template>
                              <tr :key="`sr_phys_${sectorRole._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                                  <b-tooltip
                                    :target="`sr_phys_${sectorRole._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                                    placement="auto"
                                    triggers="hover"
                                    custom-class="custom-tooltip"
                                  >
                                    <section v-if='(legalSearch.attachment11 && legalSearch.attachment11.group) || legalSearch.nameAttachment11'>
                                      <span class='p-2 text-white' style='font-size: 15px'>
                                        Este agente consta na NR 15 com o seguinte nome:
                                        {{ legalSearch.attachment11 && legalSearch.attachment11.group ? legalSearch.attachment11.group : legalSearch.nameAttachment11 ? legalSearch.nameAttachment11 : '-' }}
                                      </span> <br/><br/>
                                    </section>
                                    <section class='p-2' v-if='legalSearch.acgih && legalSearch.agent'>
                                      <span class='text-white' style='font-size: 15px'>
                                        Este agente já foi citado na ACGIH com o nome:
                                        {{ legalSearch.agent ? legalSearch.agent : '-' }}
                                      </span>
                                      <br/><br/>
                                    </section>
                                    <a :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${legalSearch.cas}`" target='_blank' class='link-pubchem-cas ml-2'>
                                      <span>Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{ legalSearch.cas }}</span>
                                    </a>
                                  </b-tooltip>
                                  <a href="#" class='hover_links word-break' :id="`sr_phys_${sectorRole._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                    <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                  </a>
                                  <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                                    <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                                      <span>Ver orientações <br/> especificas</span>
                                    </button>
                                  </section>
                                </td>
                              </tr>
                            </template>

                            <template>
                              <tr :key='`sr_phys_row1_${sectorRole._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                <template v-for="field in model.tableFieldsPhysicalBiological">
                                  <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                                    <template v-if="field.key === 'group'">
                                      <b-tooltip v-if="getGroupLtcat(model.getGroup(legalSearch))" :target="`sr_phys_group_${sectorRole._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                        <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                                      </b-tooltip>
                                      <a class='hover_links' href="#" :id="`sr_phys_group_${sectorRole._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                        <span>
                                          {{ model.getGroup(legalSearch) }}
                                          <b-icon v-if="getGroupLtcat(model.getGroup(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                        </span>
                                      </a>
                                    </template>
                                    <template v-else>
                                      <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, {}, {})"/>
                                    </template>
                                  </td>
                                </template>
                              </tr>

                              <tr :key='`sr_phys_row2_${sectorRole._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                <td colspan='9'>
                                  <p class='title-observation'>
                                    Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                                    Ela não é uma conclusão de laudo técnico.
                                  </p>
                                  <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                                    <section class='d-flex'>
                                      <p class='observation transition'>
                                        <span
                                          class='transition'
                                          v-html="model.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)">
                                        </span>
                                        <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                                          Clique para expandir ...
                                        </strong>
                                      </p>
                                    </section>
                                    <section class='pl-3'>
                                      <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                                    </section>
                                  </section>
                                </td>
                              </tr>
                            </template>
                          </template>
                        </tbody>
                      </table>
                    </section>
                  </section>

                  <!-- ===== RISCOS BIOLÓGICOS ===== -->
                  <section v-if="getRolesLegalsearches(sectorRole, 'biologico')" class="margin-top-2">
                    <section class='risk-biological d-flex align-items-center justify-content-between px-3 py-2 margin-top-1'>
                      <strong class='risk-text'>Riscos Biológicos</strong>
                      <button
                        class='btn-expand-collapse-navy-blue'
                        @click="toggleRiskOpen(sectorRole, 'biologicalRiskOpen')"
                        :class="sectorRole.biologicalRiskOpen ? '' : 'pulse-global'"
                      >
                        {{ sectorRole.biologicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>
                    <section v-if='sectorRole.biologicalRiskOpen' class='transition margin-left-25'>
                      <table class="text-center table b-table table-bordered custom-table margin-top-1">
                        <thead class='sticky'>
                          <tr class='header-table-biological'>
                            <th rowspan="2">CAS: Agente</th>
                            <th rowspan="2">Detalhes do agente</th>
                            <th rowspan="2">Limites de tolerância</th>
                            <th rowspan="2">Forma de avaliação</th>
                            <th rowspan="2">Relação com a NR 15</th>
                            <th colspan="2">Decreto 3048/99 - Anexo IV</th>
                            <th rowspan="2">Informações Previdenciárias Adicionais</th>
                            <th rowspan="2">ESOCIAL - Tabela 24</th>
                          </tr>
                          <tr class='header-table-biological'>
                            <th>Grupo</th>
                            <th>Código</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(legalSearch, indexLegalSearch) in getAgentsByRisk(sectorRole, 'biologico')">
                            <template>
                              <tr :key="`sr_bio_${sectorRole._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                                  <b-tooltip
                                    :target="`sr_bio_${sectorRole._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                                    placement="auto"
                                    triggers="hover"
                                    custom-class="custom-tooltip"
                                  >
                                    <section v-if='(legalSearch.attachment11 && legalSearch.attachment11.group) || legalSearch.nameAttachment11'>
                                      <span class='p-2 text-white' style='font-size: 15px'>
                                        Este agente consta na NR 15 com o seguinte nome:
                                        {{ legalSearch.attachment11 && legalSearch.attachment11.group ? legalSearch.attachment11.group : legalSearch.nameAttachment11 ? legalSearch.nameAttachment11 : '-' }}
                                      </span> <br/><br/>
                                    </section>
                                    <section class='p-2' v-if='legalSearch.acgih && legalSearch.agent'>
                                      <span class='text-white' style='font-size: 15px'>
                                        Este agente já foi citado na ACGIH com o nome:
                                        {{ legalSearch.agent ? legalSearch.agent : '-' }}
                                      </span>
                                      <br/><br/>
                                    </section>
                                    <a :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${legalSearch.cas}`" target='_blank' class='link-pubchem-cas ml-2'>
                                      <span>Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{ legalSearch.cas }}</span>
                                    </a>
                                  </b-tooltip>
                                  <a href="#" class='hover_links word-break' :id="`sr_bio_${sectorRole._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                    <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                  </a>
                                  <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                                    <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                                      <span>Ver orientações <br/> especificas</span>
                                    </button>
                                  </section>
                                </td>
                              </tr>
                            </template>

                            <template>
                              <tr :key='`sr_bio_row1_${sectorRole._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                <template v-for="field in model.tableFieldsPhysicalBiological">
                                  <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                                    <template v-if="field.key === 'group'">
                                      <b-tooltip v-if="getGroupLtcat(model.getGroup(legalSearch))" :target="`sr_bio_group_${sectorRole._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                        <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                                      </b-tooltip>
                                      <a class='hover_links' href="#" :id="`sr_bio_group_${sectorRole._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                        <span>
                                          {{ model.getGroup(legalSearch) }}
                                          <b-icon v-if="getGroupLtcat(model.getGroup(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                        </span>
                                      </a>
                                    </template>
                                    <template v-else>
                                      <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"/>
                                    </template>
                                  </td>
                                </template>
                              </tr>

                              <tr :key='`sr_bio_row2_${sectorRole._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                <td colspan='9'>
                                  <p class='title-observation'>
                                    Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                                    Ela não é uma conclusão de laudo técnico.
                                  </p>
                                  <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                                    <section class='d-flex'>
                                      <p class='observation transition'>
                                        <span class='transition' v-html="model.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)">

                                        </span>
                                        <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                                          Clique para expandir ...
                                        </strong>
                                      </p>
                                    </section>
                                    <section class='pl-3'>
                                      <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                                    </section>
                                  </section>
                                </td>
                              </tr>
                            </template>
                          </template>
                        </tbody>
                      </table>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>

      <section v-if='rolesHierarchy && rolesHierarchy.length > 0'>
        <hr/>
      </section>

      <section v-if='rolesHierarchy && rolesHierarchy.length > 0' class='w-100'>
        <section class='risk-chemical d-flex align-items-center justify-content-center pt-3 pb-1 text-center w-100'>
          <h6><strong>Agentes vinculados a produtos e cargos sem setor.</strong></h6>
        </section>

        <section
          v-for='roleItem in rolesHierarchy'
          :key='roleItem._id'
          class='margin-left-25 margin-top-1'
        >
              <section :id="roleItem._id" v-if="roleItem && roleItem.role">
                <section class='cargo-header d-flex align-items-center justify-content-between'>
                  <section class="ml-3">
                    <span class='cargo-name '>Cargo - {{ roleItem.role.name }}</span>
                  </section>

                  <section class=" d-flex align-items-center justify-content-between">

                    <section>
                      <button
                        class='btn-expand-collapse-navy-blue mr-3'
                        @click='toggleRoleOpen(roleItem)'
                        :class="roleItem.open ? '' : 'pulse-global'"
                      >
                        {{ roleItem.open ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>
                  </section>
                </section>

                <section v-if='roleItem && roleItem.open' class="margin-left-25">
                  <!-- ===== RISCOS QUÍMICOS ===== -->
                  <section
                    v-if="roleItem.role && roleItem.role.rolesProductsLegalConsultation && roleItem.role.rolesProductsLegalConsultation.length > 0"
                    class="margin-top-2"
                  >
                    <section class='risk-chemical d-flex align-items-center justify-content-between py-2'>
                      <section class="ml-3">
                        <strong class='risk-text'>Riscos Químicos</strong>
                      </section>

                      <section class="mr-3">
                        <button
                          class='btn-expand-collapse-navy-blue'
                          @click="toggleRoleRiskOpen(roleItem, 'chemicalRiskOpen')"
                          :class="roleItem.chemicalRiskOpen ? '' : 'pulse-global'"
                        >
                          {{ roleItem.chemicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                        </button>
                      </section>
                    </section>

                    <section class="margin-left-25 margin-top-2">
                      <section
                        v-for='(roleProductLegalConsultation, indexRoleProduct) in roleItem.role.rolesProductsLegalConsultation'
                        :key='roleProductLegalConsultation._id'
                        v-show="roleItem.chemicalRiskOpen"
                      >
                        <hr v-if='indexRoleProduct > 0' />
                        <section
                          v-if='roleProductLegalConsultation && roleProductLegalConsultation.product'
                          :id='roleProductLegalConsultation._id'
                          class='product'
                        >
                          <section
                            class='product d-flex align-items-center justify-content-between'
                            style='background: #DADADA'
                          >
                            <section class='d-flex align-items-center justify-content-start h-100 ml-3'>
                              <span class='name'>
                                Produto: {{ roleProductLegalConsultation.product.name }}
                              </span>
                            </section>

                            <section class='d-flex align-items-center justify-content-between mr-3'>

                              <button
                                class='btn-expand-collapse-navy-blue'
                                @click="toggleRoleProductOpen(roleProductLegalConsultation.product)"
                                :class="roleProductLegalConsultation.product.open ? '' : 'pulse-global'"
                              >
                                {{ roleProductLegalConsultation.product.open ? 'Recolher informações' : 'Expandir informações' }}
                              </button>
                            </section>
                          </section>

                          <table
                            style="margin-top: 0"
                            v-if="roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.open"
                            class="text-center table b-table table-bordered custom-table"
                          >
                            <thead class='sticky '>
                              <tr class='header-table-chemical'>
                                <th rowspan="2">CAS: Agente</th>
                                <th rowspan="2">Detalhes do Agente</th>
                                <th rowspan="2">Lista de Atividades</th>
                                <th rowspan="2">Forma de avaliação</th>
                                <th rowspan="2">Relação com a NR 15</th>
                                <th colspan="2">Decreto 3048/99 - Anexo IV</th>
                                <th rowspan="2">Informações Previdenciárias Adicionais</th>
                                <th rowspan="2">Linach</th>
                                <th rowspan="2">ESOCIAL - Tabela 24</th>
                              </tr>
                              <tr class='header-table-chemical'>
                                <th>Grupo</th>
                                <th>Código</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="(legalSearch, indexLegalSearch) in roleProductLegalConsultation.product.legalSearches_">
                                <template>
                                  <tr :key="`sr_chem_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                                      <b-tooltip
                                        :target="`sr_chem_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                                        placement="auto"
                                        triggers="hover"
                                        custom-class="custom-tooltip"
                                      >
                                        <section v-if='(legalSearch.attachment11 && legalSearch.attachment11.group) || legalSearch.nameAttachment11'>
                                          <span class='p-2 text-white' style='font-size: 15px'>
                                            Este agente consta na NR 15 com o seguinte nome:
                                            {{ legalSearch.attachment11 && legalSearch.attachment11.group ? legalSearch.attachment11.group : legalSearch.nameAttachment11 ? legalSearch.nameAttachment11 : '-' }}
                                          </span> <br/><br/>
                                        </section>
                                        <section class='p-2' v-if='legalSearch.acgih && legalSearch.agent'>
                                          <span class='text-white' style='font-size: 15px'>
                                            Este agente já foi citado na ACGIH com o nome:
                                            {{ legalSearch.agent ? legalSearch.agent : '-' }}
                                          </span>
                                          <br/><br/>
                                        </section>
                                        <a :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${legalSearch.cas}`" target='_blank' class='link-pubchem-cas ml-2'>
                                          <span>Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{ legalSearch.cas }}</span>
                                        </a>
                                      </b-tooltip>

                                      <a href="#" class='hover_links word-break' :id="`sr_chem_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                        <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                        <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                      </a>

                                      <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                                        <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                                          <span>Ver orientações <br/> especificas</span>
                                        </button>
                                      </section>
                                    </td>
                                  </tr>
                                </template>

                                <template v-if="model.getActivity(legalSearch)">
                                  <tr :key='`sr_chem_row1_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                    <template v-for="field in model.tableFields">
                                      <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                                        <template v-if="field.key === 'activities'">
                                          <a class='hover_links' href="#" v-b-tooltip.lefttop.hover.html
                                            :title="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"
                                            v-if="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"
                                            @click="displayActivities(legalSearch, model.isActivitySpecific(legalSearch))">
                                            <span class='d-flex align-items-center justify-content-center'>
                                              Selecionadas
                                              <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                            </span>
                                          </a>
                                          <a href="#" v-else>-</a>
                                        </template>

                                        <template v-else-if="field.key === 'evaluation'">
                                          <span v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"></span>
                                          <a class='hover_links' href="#" v-b-tooltip.lefttop.hover.html
                                            title="Clique aqui para selecionar a sua interpretação sobre esse agente"
                                            v-if="legalSearch.legalInterpretation"
                                            @click="displayLegalInterpretation(legalSearch)">
                                            <span class='d-flex align-items-center justify-content-center'>
                                              Interpretação jurídica
                                              <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                            </span>
                                          </a>
                                        </template>

                                        <template v-else>
                                          <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"/>
                                        </template>

                                        <template v-if="field.key === 'agentDetails'">
                                          <section>
                                            <b-tooltip :target="`sr_chem_taxonomy_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="topright" triggers="hover">
                                              <div v-if="legalSearch.taxonomy && legalSearch.taxonomy.agentDescription">
                                                <strong class='text-white mb-4'>Descrição do agente</strong>
                                                <br/>
                                                <span class='text-white mt-4'>{{ legalSearch.taxonomy.agentDescription }}</span>
                                                <br/>
                                                <taxonomy :taxonomy="legalSearch.taxonomy"/>
                                              </div>
                                              <div v-else>
                                                <span>Por hora não temos informações sobre a taxonomia e descrição deste agente químico. Estamos trabalhando constantemente na atualização e inclusão de novas informações e no futuro este agente poderá apresentar mais informações.</span>
                                              </div>
                                            </b-tooltip>
                                            <a class='hover_links' href="#" :id="`sr_chem_taxonomy_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                              <span class='d-flex align-items-center justify-content-center'>
                                                Ver descrição
                                                <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                              </span>
                                            </a>
                                          </section>
                                          <section class='mt-2'>
                                            <b-tooltip :target="`sr_chem_harmfulness_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                              <span v-html='getPhraseList(legalSearch)'></span>
                                            </b-tooltip>
                                            <a class='hover_links' href="#" :id="`sr_chem_harmfulness_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                              <span class='d-flex align-items-center justify-content-center'>
                                                Ver nocividade
                                                <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                              </span>
                                            </a>
                                          </section>
                                        </template>

                                        <template v-if="field.key === 'group'">
                                          <b-tooltip v-if="getGroupLtcat(model.getGroup(legalSearch))" :target="`sr_chem_group_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                            <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                                          </b-tooltip>
                                          <a class='hover_links' href="#" :id="`sr_chem_group_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                            <span>
                                              {{ model.getGroup(legalSearch) }}
                                              <b-icon v-if="getGroupLtcat(model.getGroup(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                            </span>
                                          </a>
                                        </template>

                                        <template v-if="field.key === 'base'">
                                          <b-tooltip v-if="getGroupUnhealthy(model.getBase(legalSearch))" :target="`sr_chem_base_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                            <span class='text-white'>{{ getGroupUnhealthy(model.getBase(legalSearch)) }}</span>
                                          </b-tooltip>
                                          <a class='hover_links' href="#" :id="`sr_chem_base_${roleProductLegalConsultation._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                            <span>
                                              {{ model.getBase(legalSearch) }}
                                              <b-icon v-if="getGroupUnhealthy(model.getBase(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                            </span>
                                          </a>
                                        </template>
                                      </td>
                                    </template>
                                  </tr>

                                  <tr :key='`sr_chem_row2_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                    <td colspan='9'>
                                      <p class='title-observation'>
                                        Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                                        Ela não é uma conclusão de laudo técnico.
                                      </p>
                                      <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                                        <section class='d-flex'>
                                          <p class='observation transition'>
                                            <span class='transition' v-html="analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, exposicaoPermanente, protecaoEficaz).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, exposicaoPermanente, protecaoEficaz).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)"></span>
                                            <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                                              Clique para expandir ...
                                            </strong>
                                          </p>
                                        </section>
                                        <section class='pl-3'>
                                          <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                                        </section>
                                      </section>
                                    </td>
                                  </tr>
                                </template>

                                <template v-else>
                                  <tr v-if="model.verificarGrupoBenzenoSeusCompostosToxicos(model.getGroup(legalSearch), legalSearch)" :key="`sr_chem_row4_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <td colspan="10" class="selectable-row">
                                      <a href="#" @click="displayLegalInterpretation(legalSearch)">
                                        <span class='selectable-row-text'>Agente necessita de interpretação jurídica selecione aqui</span>
                                      </a>
                                    </td>
                                  </tr>
                                  <tr v-else :key="`sr_chem_row3_${roleProductLegalConsultation._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <td colspan="10" class="selectable-row">
                                      <a href="#" @click="displayActivities(legalSearch, model.isActivitySpecific(legalSearch))">
                                        <span class='selectable-row-text'>Agente necessita de determinação de atividade, selecione aqui</span>
                                      </a>
                                    </td>
                                  </tr>
                                </template>
                              </template>
                            </tbody>
                          </table>
                        </section>
                      </section>
                    </section>
                  </section>

                  <section v-if="getRolesLegalsearches(roleItem, 'fisico')" class="margin-top-2">
                    <section class='risk-physical d-flex align-items-center justify-content-between py-2'>
                      <strong class='risk-text ml-3'>Riscos Físicos</strong>
                      <button
                        class='btn-expand-collapse-navy-blue mr-3'
                        :class="roleItem.physicalRiskOpen ? '' : 'pulse-global'"
                        @click="toggleRoleRiskOpen(roleItem, 'physicalRiskOpen')"
                      >
                        {{ roleItem.physicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>
                    <section v-if="roleItem.physicalRiskOpen" class='transition margin-left-25'>
                      <table class="text-center table b-table table-bordered custom-table margin-top-1">
                        <thead class='sticky'>
                          <tr class='header-table-physical'>
                            <th rowspan="2">CAS: Agente</th>
                            <th rowspan="2">Detalhes do agente</th>
                            <th rowspan="2">Limites de tolerância</th>
                            <th rowspan="2">Forma de avaliação</th>
                            <th rowspan="2">Relação com a NR 15</th>
                            <th colspan="2">Decreto 3048/99 - Anexo IV</th>
                            <th rowspan="2">Informações Previdenciárias Adicionais</th>
                            <th rowspan="2">ESOCIAL - Tabela 24</th>
                          </tr>
                          <tr class='header-table-physical'>
                            <th>Grupo</th>
                            <th>Código</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(legalSearch, indexLegalSearch) in getAgentsByRisk(roleItem, 'fisico')">
                            <template>
                              <tr :key="`sr_phys_${roleItem._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                                  <b-tooltip
                                    :target="`sr_phys_${roleItem._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                                    placement="auto"
                                    triggers="hover"
                                    custom-class="custom-tooltip"
                                  >
                                    <section v-if='(legalSearch.attachment11 && legalSearch.attachment11.group) || legalSearch.nameAttachment11'>
                                      <span class='p-2 text-white' style='font-size: 15px'>
                                        Este agente consta na NR 15 com o seguinte nome:
                                        {{ legalSearch.attachment11 && legalSearch.attachment11.group ? legalSearch.attachment11.group : legalSearch.nameAttachment11 ? legalSearch.nameAttachment11 : '-' }}
                                      </span> <br/><br/>
                                    </section>
                                    <section class='p-2' v-if='legalSearch.acgih && legalSearch.agent'>
                                      <span class='text-white' style='font-size: 15px'>
                                        Este agente já foi citado na ACGIH com o nome:
                                        {{ legalSearch.agent ? legalSearch.agent : '-' }}
                                      </span>
                                      <br/><br/>
                                    </section>
                                    <a :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${legalSearch.cas}`" target='_blank' class='link-pubchem-cas ml-2'>
                                      <span>Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{ legalSearch.cas }}</span>
                                    </a>
                                  </b-tooltip>
                                  <a href="#" class='hover_links word-break' :id="`sr_phys_${roleItem._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                    <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                  </a>
                                  <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                                    <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                                      <span>Ver orientações <br/> especificas</span>
                                    </button>
                                  </section>
                                </td>
                              </tr>
                            </template>

                            <template>
                              <tr :key='`sr_phys_row1_${roleItem._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                <template v-for="field in model.tableFieldsPhysicalBiological">
                                  <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                                    <template v-if="field.key === 'group'">
                                      <b-tooltip v-if="getGroupLtcat(model.getGroup(legalSearch))" :target="`sr_phys_group_${roleItem._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                        <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                                      </b-tooltip>
                                      <a class='hover_links' href="#" :id="`sr_phys_group_${roleItem._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                        <span>
                                          {{ model.getGroup(legalSearch) }}
                                          <b-icon v-if="getGroupLtcat(model.getGroup(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                        </span>
                                      </a>
                                    </template>
                                    <template v-else>
                                      <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, {}, {})"/>
                                    </template>
                                  </td>
                                </template>
                              </tr>

                              <tr :key='`sr_phys_row2_${roleItem._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                <td colspan='9'>
                                  <p class='title-observation'>
                                    Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                                    Ela não é uma conclusão de laudo técnico.
                                  </p>
                                  <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                                    <section class='d-flex'>
                                      <p class='observation transition'>
                                        <span
                                          class='transition'
                                          v-html="model.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)">
                                        </span>
                                        <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                                          Clique para expandir ...
                                        </strong>
                                      </p>
                                    </section>
                                    <section class='pl-3'>
                                      <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                                    </section>
                                  </section>
                                </td>
                              </tr>
                            </template>
                          </template>
                        </tbody>
                      </table>
                    </section>
                  </section>

                  <!-- ===== RISCOS BIOLÓGICOS ===== -->
                  <section v-if="getRolesLegalsearches(roleItem, 'biologico')" class="margin-top-2">
                    <section class='risk-biological d-flex align-items-center justify-content-between px-3 py-2 margin-top-1'>
                      <strong class='risk-text'>Riscos Biológicos</strong>
                      <button
                        class='btn-expand-collapse-navy-blue'
                        @click="toggleRoleRiskOpen(roleItem, 'biologicalRiskOpen')"
                        :class="roleItem.biologicalRiskOpen ? '' : 'pulse-global'"
                      >
                        {{ roleItem.biologicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>
                    <section v-if='roleItem.biologicalRiskOpen' class='transition margin-left-25'>
                      <table class="text-center table b-table table-bordered custom-table margin-top-1">
                        <thead class='sticky'>
                          <tr class='header-table-biological'>
                            <th rowspan="2">CAS: Agente</th>
                            <th rowspan="2">Detalhes do agente</th>
                            <th rowspan="2">Limites de tolerância</th>
                            <th rowspan="2">Forma de avaliação</th>
                            <th rowspan="2">Relação com a NR 15</th>
                            <th colspan="2">Decreto 3048/99 - Anexo IV</th>
                            <th rowspan="2">Informações Previdenciárias Adicionais</th>
                            <th rowspan="2">ESOCIAL - Tabela 24</th>
                          </tr>
                          <tr class='header-table-biological'>
                            <th>Grupo</th>
                            <th>Código</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(legalSearch, indexLegalSearch) in getAgentsByRisk(roleItem, 'biologico')">
                            <template>
                              <tr :key="`sr_bio_${roleItem._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                                  <b-tooltip
                                    :target="`sr_bio_${roleItem._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                                    placement="auto"
                                    triggers="hover"
                                    custom-class="custom-tooltip"
                                  >
                                    <section v-if='(legalSearch.attachment11 && legalSearch.attachment11.group) || legalSearch.nameAttachment11'>
                                      <span class='p-2 text-white' style='font-size: 15px'>
                                        Este agente consta na NR 15 com o seguinte nome:
                                        {{ legalSearch.attachment11 && legalSearch.attachment11.group ? legalSearch.attachment11.group : legalSearch.nameAttachment11 ? legalSearch.nameAttachment11 : '-' }}
                                      </span> <br/><br/>
                                    </section>
                                    <section class='p-2' v-if='legalSearch.acgih && legalSearch.agent'>
                                      <span class='text-white' style='font-size: 15px'>
                                        Este agente já foi citado na ACGIH com o nome:
                                        {{ legalSearch.agent ? legalSearch.agent : '-' }}
                                      </span>
                                      <br/><br/>
                                    </section>
                                    <a :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${legalSearch.cas}`" target='_blank' class='link-pubchem-cas ml-2'>
                                      <span>Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{ legalSearch.cas }}</span>
                                    </a>
                                  </b-tooltip>
                                  <a href="#" class='hover_links word-break' :id="`sr_bio_${roleItem._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                    <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                  </a>
                                  <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                                    <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                                      <span>Ver orientações <br/> especificas</span>
                                    </button>
                                  </section>
                                </td>
                              </tr>
                            </template>

                            <template>
                              <tr :key='`sr_bio_row1_${roleItem._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                <template v-for="field in model.tableFieldsPhysicalBiological">
                                  <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                                    <template v-if="field.key === 'group'">
                                      <b-tooltip v-if="getGroupLtcat(model.getGroup(legalSearch))" :target="`sr_bio_group_${roleItem._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                        <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                                      </b-tooltip>
                                      <a class='hover_links' href="#" :id="`sr_bio_group_${roleItem._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                        <span>
                                          {{ model.getGroup(legalSearch) }}
                                          <b-icon v-if="getGroupLtcat(model.getGroup(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                        </span>
                                      </a>
                                    </template>
                                    <template v-else>
                                      <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"/>
                                    </template>
                                  </td>
                                </template>
                              </tr>

                              <tr :key='`sr_bio_row2_${roleItem._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                                <td colspan='9'>
                                  <p class='title-observation'>
                                    Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                                    Ela não é uma conclusão de laudo técnico.
                                  </p>
                                  <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                                    <section class='d-flex'>
                                      <p class='observation transition'>
                                        <span class='transition' v-html="model.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)">

                                        </span>
                                        <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                                          Clique para expandir ...
                                        </strong>
                                      </p>
                                    </section>
                                    <section class='pl-3'>
                                      <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                                    </section>
                                  </section>
                                </td>
                              </tr>
                            </template>
                          </template>
                        </tbody>
                      </table>
                    </section>
                  </section>
                </section>
              </section>
        </section>
      </section>

      <section v-show="productsLegalConsultation && productsLegalConsultation.length > 0">
        <hr/>
      </section>

      <section
        v-show="productsLegalConsultation && productsLegalConsultation.length > 0"
        class="my-3"
      >
        <section class='risk-chemical d-flex align-items-center justify-content-center pt-3 pb-1 text-center w-100'>
          <h6><strong>Agentes pesquisados vinculados a produtos e sem vínculo com cargos.</strong></h6>
        </section>

        <section class='risk-chemical d-flex align-items-center justify-content-between px-3 py-2'>
          <section>
            <strong class='risk-text'>Riscos Químicos</strong>
          </section>
          <section>
            <button class='btn-expand-collapse-navy-blue' @click="toggleChemicalExpanded('tabLtcatChemicalRiskOpenAgentsLinkedProductWithoutRole')">
              {{ userPreferences && userPreferences.tabLtcatChemicalRiskOpenAgentsLinkedProductWithoutRole ? 'Recolher informações' : 'Expandir informações' }}
            </button>
          </section>
        </section>


        <section
          class='transition margin-left-25'
          v-if="userPreferences && userPreferences.tabLtcatChemicalRiskOpenAgentsLinkedProductWithoutRole"
        >
          <table class="margin-top-1 text-center table b-table table-bordered custom-table">
            <thead class='sticky'>
            <tr class='header-table-chemical'>
              <th rowspan="2">Produto</th>
              <th rowspan="2">CAS: Agente</th>
              <th rowspan="2">Detalhes do Agente</th>
              <th rowspan="2">Lista de Atividades</th>
              <th rowspan="2">Forma de avaliação</th>
              <th rowspan="2">Relação com a NR 15</th>
              <th colspan="2">Decreto 3048/99 - Anexo IV</th>
              <th rowspan="2">Informações Previdenciárias Adicionais</th>
              <th rowspan="2">Linach</th>
              <th rowspan="2">ESOCIAL - Tabela 24</th>
            </tr>
            <tr class='header-table-chemical'>
              <th>Grupo</th>
              <th>Código</th>
            </tr>
            </thead>
            <tbody>
            <template v-for='item in productsLegalConsultation'>
              <template v-for="(legalSearch, indexLegalSearch) in item.legalSearches">
                <template>
                  <tr :key="`wr_chem_${item._id || 'noid'}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                    <td
                      v-if='legalSearch.index < 1 || item._id === `-`'
                      :rowspan="rowspan(item, legalSearch)"
                    >
                            <span v-if='item.name' class='word-break'>
                              {{ item.name }}
                            </span>
                      <span v-else class='word-break'>-</span>

                      <section class='mt-2' v-if='item._id && synergisticRiskProducts && synergisticRiskProducts.length > 0 && !!synergisticRiskProducts.find((x) => x.product === item._id)'>
                        <b-tooltip
                          :target="`wr_chem_synergistic_${item._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                          custom-class="custom-tooltip"
                          placement="auto"
                          triggers="hover"
                        >
                          <strong>Este produto contém agentes químicos que afetam de forma acumulativa o mesmo órgão ou sistema alvo:</strong> <br/>
                          <ul class='phrases mt-2'>
                            <li v-for='phrase in synergisticRiskProducts.find((x) => x.product === item._id).phrases' :key='phrase'>
                              {{ phrase }}
                            </li>
                          </ul>
                        </b-tooltip>
                        <button class='btn-synergistic-risk' :id="`wr_chem_synergistic_${item._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                          <svg width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.034 8.5645L10.6878 1.2175C10.4057 0.93712 10.0242 0.779739 9.62651 0.779739C9.22882 0.779739 8.8473 0.93712 8.56526 1.2175L1.21901 8.5645C0.93863 8.84654 0.78125 9.22806 0.78125 9.62575C0.78125 10.0234 0.93863 10.405 1.21901 10.687L8.56601 18.0333C9.14952 18.6168 10.1035 18.6168 10.6885 18.0333L18.0355 10.6863C18.3151 10.4041 18.4719 10.023 18.4719 9.62575C18.4719 9.22855 18.3151 8.84741 18.0355 8.56525L18.034 8.5645Z" fill="#022245"/>
                          </svg>
                        </button>
                      </section>
                    </td>

                    <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                      <b-tooltip
                        :target="`wr_chem_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                        placement="auto"
                        triggers="hover"
                        custom-class="custom-tooltip"
                      >
                        <section v-if='(legalSearch.attachment11 && legalSearch.attachment11.group) || legalSearch.nameAttachment11'>
                                <span class='p-2 text-white' style='font-size: 15px'>
                                  Este agente consta na NR 15 com o seguinte nome:
                                  {{ legalSearch.attachment11 && legalSearch.attachment11.group ? legalSearch.attachment11.group : legalSearch.nameAttachment11 ? legalSearch.nameAttachment11 : '-' }}
                                </span> <br/><br/>
                        </section>
                        <section class='p-2' v-if='legalSearch.acgih && legalSearch.agent'>
                                <span class='text-white' style='font-size: 15px'>
                                  Este agente já foi citado na ACGIH com o nome:
                                  {{ legalSearch.agent ? legalSearch.agent : '-' }}
                                </span>
                          <br/><br/>
                        </section>
                        <a :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${legalSearch.cas}`" target='_blank' class='link-pubchem-cas ml-2'>
                          <span>Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{ legalSearch.cas }}</span>
                        </a>
                      </b-tooltip>

                      <a href="#" class='hover_links word-break' :id="`wr_chem_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                        <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                        <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                      </a>

                      <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                        <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                          <span>Ver orientações <br/> especificas</span>
                        </button>
                      </section>
                    </td>
                  </tr>
                </template>

                <template v-if="model.getActivity(legalSearch)">
                  <tr :key='`wr_chem_row1_${(item.product && item.product._id) || "noid"}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                    <template v-for="field in model.tableFields">
                      <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                        <template v-if="field.key === 'activities'">
                          <a class='hover_links' href="#" v-b-tooltip.lefttop.hover.html
                             :title="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"
                             v-if="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"
                             @click="displayActivities(legalSearch, model.isActivitySpecific(legalSearch))">
                                  <span class='d-flex align-items-center justify-content-center'>
                                    Selecionadas
                                    <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                  </span>
                          </a>
                          <a href="#" v-else>-</a>
                        </template>
                        <template v-else-if="field.key === 'evaluation'">
                          <span v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"></span>
                          <a class='hover_links' href="#" v-b-tooltip.lefttop.hover.html
                             title="Clique aqui para selecionar a sua interpretação sobre esse agente"
                             v-if="legalSearch.legalInterpretation"
                             @click="displayLegalInterpretation(legalSearch)">
                                  <span class='d-flex align-items-center justify-content-center'>
                                    Interpretação jurídica
                                    <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                  </span>
                          </a>
                        </template>
                        <template v-else>
                          <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"/>
                        </template>

                        <template v-if="field.key === 'agentDetails'">
                          <section>
                            <b-tooltip :target="`wr_chem_taxonomy_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="topright" triggers="hover">
                              <div v-if="legalSearch.taxonomy && legalSearch.taxonomy.agentDescription">
                                <strong class='text-white mb-4'>Descrição do agente</strong>
                                <br/>
                                <span class='text-white mt-4'>{{ legalSearch.taxonomy.agentDescription }}</span>
                                <br/>
                                <taxonomy :taxonomy="legalSearch.taxonomy"/>
                              </div>
                              <div v-else>
                                <span>Por hora não temos informações sobre a taxonomia e descrição deste agente químico.</span>
                              </div>
                            </b-tooltip>
                            <a class='hover_links' href="#" :id="`wr_chem_taxonomy_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <span class='d-flex align-items-center justify-content-center'>
                                      Ver descrição
                                      <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                    </span>
                            </a>
                          </section>
                          <section class='mt-2'>
                            <b-tooltip :target="`wr_chem_harmfulness_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                              <span v-html='getPhraseList(legalSearch)'></span>
                            </b-tooltip>
                            <a class='hover_links' href="#" :id="`wr_chem_harmfulness_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                    <span class='d-flex align-items-center justify-content-center'>
                                      Ver nocividade
                                      <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                    </span>
                            </a>
                          </section>
                        </template>

                        <template v-if="field.key === 'group'">
                          <b-tooltip v-if="getGroupLtcat(model.getGroup(legalSearch))" :target="`wr_chem_group_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                            <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                          </b-tooltip>
                          <a class='hover_links' href="#" :id="`wr_chem_group_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                  <span>
                                    {{ model.getGroup(legalSearch) }}
                                    <b-icon v-if="getGroupLtcat(model.getGroup(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                  </span>
                          </a>
                        </template>

                        <template v-if="field.key === 'base'">
                          <b-tooltip v-if="getGroupUnhealthy(model.getBase(legalSearch))" :target="`wr_chem_base_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                            <span class='text-white'>{{ getGroupUnhealthy(model.getBase(legalSearch)) }}</span>
                          </b-tooltip>
                          <a class='hover_links' href="#" :id="`wr_chem_base_${item._id || 'noid'}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                  <span>
                                    {{ model.getBase(legalSearch) }}
                                    <b-icon v-if="getGroupUnhealthy(model.getBase(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                  </span>
                          </a>
                        </template>
                      </td>
                    </template>
                  </tr>

                  <tr :key='`wr_chem_row2_${(item.product && item.product._id) || "noid"}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                    <td colspan='9'>
                      <p class='title-observation'>
                        Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                        Ela não é uma conclusão de laudo técnico.
                      </p>
                      <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                        <section class='d-flex'>
                          <p class='observation transition'>
                            <span class='transition' v-html="analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, exposicaoPermanente, protecaoEficaz).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, exposicaoPermanente, protecaoEficaz).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)"></span>
                            <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                              Clique para expandir ...
                            </strong>
                          </p>
                        </section>
                        <section class='pl-3'>
                          <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                        </section>
                      </section>
                    </td>
                  </tr>
                </template>

                <template v-else>
                  <tr v-if="model.verificarGrupoBenzenoSeusCompostosToxicos(model.getGroup(legalSearch), legalSearch)" :key="`wr_chem_row4_${item._id || 'noid'}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                    <td colspan="11" class="selectable-row">
                      <a href="#" @click="displayLegalInterpretation(legalSearch)">
                        <span class='selectable-row-text'>Agente necessita de interpretação jurídica selecione aqui</span>
                      </a>
                    </td>
                  </tr>
                  <tr v-else :key="`wr_chem_row3_${item._id || 'noid'}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                    <td colspan="11" class="selectable-row">
                      <a href="#" @click="displayActivities(legalSearch, model.isActivitySpecific(legalSearch))">
                        <span class='selectable-row-text'>Agente necessita de determinação de atividade, selecione aqui</span>
                      </a>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
            </tbody>
          </table>
        </section>
      </section>

      <section v-show="agentsWithoutProduct && agentsWithoutProduct.length > 0">
        <hr/>
      </section>
      <section
        v-show="agentsWithoutProduct && agentsWithoutProduct.length > 0"
        v-for='agentWithoutProduct in agentsWithoutProduct'
        :key="agentWithoutProduct._id"
        class="mt-1"
      >
        <section v-if="agentWithoutProduct.riskType === 'quimico'">
          <section class='risk-chemical d-flex align-items-center justify-content-center pt-3 pb-1 text-center w-100'>
            <h6><strong>Agentes pesquisados sem vínculo de produto ou cargo.</strong></h6>
          </section>

          <section class='risk-chemical d-flex align-items-center margin-top-2 justify-content-between px-3 py-2'>
            <section>
              <strong class='risk-text'>Riscos Químicos</strong>
            </section>
            <section>
              <button class='btn-expand-collapse-navy-blue' @click="toggleChemicalExpanded('tabLtcatChemicalRiskOpenAgentsWithoutProductAffiliation')">
                {{ userPreferences && userPreferences.tabLtcatChemicalRiskOpenAgentsWithoutProductAffiliation ? 'Recolher informações' : 'Expandir informações' }}
              </button>
            </section>
          </section>

          <section class="margin-left-25">
            <table
              v-if="userPreferences && userPreferences.tabLtcatChemicalRiskOpenAgentsWithoutProductAffiliation"
              class="text-center table b-table table-bordered custom-table margin-top-1"
            >
              <thead class="sticky">
                <tr class='header-table-chemical'>
                  <th rowspan="2">Produto</th>
                  <th rowspan="2">CAS: Agente</th>
                  <th rowspan="2">Detalhes do Agente</th>
                  <th rowspan="2">Lista de Atividades</th>
                  <th rowspan="2">Forma de avaliação</th>
                  <th rowspan="2">Relação com a NR 15</th>
                  <th colspan="2">Decreto 3048/99 - Anexo IV</th>
                  <th rowspan="2">Informações Previdenciárias Adicionais</th>
                  <th rowspan="2">Linach</th>
                  <th rowspan="2">ESOCIAL - Tabela 24</th>
                </tr>
                <tr class='header-table-chemical'>
                  <th>Grupo</th>
                  <th>Código</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(legalSearch, indexLegalSearch) in agentWithoutProduct.legalSearches">
                  <template>
                    <tr :key="`wp_chem_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                      <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                        <section class='px-2'>
                          <p v-if='importedCompany && importedCompany._id' class='word-break add-agent-prouct' @click="addAAgentProduct(legalSearch.legalSearchId)">
                            Adicionar à <br/> produto
                          </p>
                          <p v-else class='word-break'>-</p>
                          <b-tooltip :target="`wp_chem_addproduct_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`" placement="auto" triggers="hover">
                            <span>É necessário que este agente esteja como constituinte de um produto para que seja possível interagir com as ferramentas de análise da aba LTCAT</span>
                          </b-tooltip>
                          <b-icon v-if='importedCompany && importedCompany._id' :id="`wp_chem_addproduct_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`" class='ml-1' font-scale="1.5" icon="info-circle-fill" variant="info"></b-icon>
                        </section>
                      </td>

                      <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                        <b-tooltip :target="`wp_chem_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" placement="auto" triggers="hover" custom-class="custom-tooltip">
                          <section v-if='(legalSearch.attachment11 && legalSearch.attachment11.group) || legalSearch.nameAttachment11'>
                            <span class='p-2 text-white' style='font-size: 15px'>
                              Este agente consta na NR 15 com o seguinte nome:
                              {{ legalSearch.attachment11 && legalSearch.attachment11.group ? legalSearch.attachment11.group : legalSearch.nameAttachment11 ? legalSearch.nameAttachment11 : '-' }}
                            </span> <br/><br/>
                          </section>
                          <section class='p-2' v-if='legalSearch.acgih && legalSearch.agent'>
                            <span class='text-white' style='font-size: 15px'>
                              Este agente já foi citado na ACGIH com o nome:
                              {{ legalSearch.agent ? legalSearch.agent : '-' }}
                            </span>
                            <br/><br/>
                          </section>
                          <a :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${legalSearch.cas}`" target='_blank' class='link-pubchem-cas ml-2'>
                            <span>Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{ legalSearch.cas }}</span>
                          </a>
                        </b-tooltip>

                        <a href="#" class='hover_links word-break' :id="`wp_chem_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                          <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                          <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                        </a>

                        <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                          <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                            <span>Ver orientações <br/> especificas</span>
                          </button>
                        </section>
                      </td>
                    </tr>
                  </template>

                  <template v-if="model.getActivity(legalSearch)">
                    <tr :key='`wp_chem_row1_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                      <template v-for="field in model.tableFields">
                        <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                          <template v-if="field.key === 'activities'">
                            <a class='hover_links' href="#" v-b-tooltip.lefttop.hover.html
                              :title="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"
                              v-if="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"
                              @click="displayActivities(legalSearch, model.isActivitySpecific(legalSearch))">
                              <span class='d-flex align-items-center justify-content-center'>
                                Selecionadas
                                <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                              </span>
                            </a>
                            <a href="#" v-else>-</a>
                          </template>
                          <template v-else-if="field.key === 'evaluation'">
                            <span v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"></span>
                            <a class='hover_links' href="#" v-b-tooltip.lefttop.hover.html
                              title="Clique aqui para selecionar a sua interpretação sobre esse agente"
                              v-if="legalSearch.legalInterpretation"
                              @click="displayLegalInterpretation(legalSearch)">
                              <span class='d-flex align-items-center justify-content-center'>
                                Interpretação jurídica
                                <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                              </span>
                            </a>
                          </template>
                          <template v-else>
                            <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, exposicaoPermanente, protecaoEficaz)"/>
                          </template>

                          <template v-if="field.key === 'agentDetails'">
                            <section>
                              <b-tooltip :target="`wp_chem_taxonomy_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="topright" triggers="hover">
                                <div v-if="legalSearch.taxonomy && legalSearch.taxonomy.agentDescription">
                                  <strong class='text-white mb-4'>Descrição do agente</strong>
                                  <br/>
                                  <span class='text-white mt-4'>{{ legalSearch.taxonomy.agentDescription }}</span>
                                  <br/>
                                  <taxonomy :taxonomy="legalSearch.taxonomy"/>
                                </div>
                                <div v-else>
                                  <span>Por hora não temos informações sobre a taxonomia e descrição deste agente químico.</span>
                                </div>
                              </b-tooltip>
                              <a class='hover_links' href="#" :id="`wp_chem_taxonomy_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                <span class='d-flex align-items-center justify-content-center'>
                                  Ver descrição
                                  <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                </span>
                              </a>
                            </section>
                            <section class='mt-2'>
                              <b-tooltip :target="`wp_chem_harmfulness_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                                <span v-html='getPhraseList(legalSearch)'></span>
                              </b-tooltip>
                              <a class='hover_links' href="#" :id="`wp_chem_harmfulness_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                                <span class='d-flex align-items-center justify-content-center'>
                                  Ver nocividade
                                  <b-icon class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                                </span>
                              </a>
                            </section>
                          </template>

                          <template v-if="field.key === 'group'">
                            <b-tooltip v-if="getGroupLtcat(model.getGroup(legalSearch))" :target="`wp_chem_group_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                              <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                            </b-tooltip>
                            <a class='hover_links' href="#" :id="`wp_chem_group_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                              <span>
                                {{ model.getGroup(legalSearch) }}
                                <b-icon v-if="getGroupLtcat(model.getGroup(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                              </span>
                            </a>
                          </template>

                          <template v-if="field.key === 'base'">
                            <b-tooltip v-if="getGroupUnhealthy(model.getBase(legalSearch))" :target="`wp_chem_base_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`" custom-class="custom-tooltip" placement="auto" triggers="hover">
                              <span class='text-white'>{{ getGroupUnhealthy(model.getBase(legalSearch)) }}</span>
                            </b-tooltip>
                            <a class='hover_links' href="#" :id="`wp_chem_base_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                              <span>
                                {{ model.getBase(legalSearch) }}
                                <b-icon v-if="getGroupUnhealthy(model.getBase(legalSearch))" class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                              </span>
                            </a>
                          </template>
                        </td>
                      </template>
                    </tr>

                    <tr :key='`wp_chem_row2_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                      <td colspan='9'>
                        <p class='title-observation'>
                          Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                          Ela não é uma conclusão de laudo técnico.
                        </p>
                        <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                          <section class='d-flex'>
                            <p class='observation transition'>
                              <span class='transition' v-html="analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, exposicaoPermanente, protecaoEficaz).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? analysisPermanentExposureAndEffectiveProtection.getValue('ps', legalSearch, exposicaoPermanente, protecaoEficaz).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)"></span>
                              <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                                Clique para expandir ...
                              </strong>
                            </p>
                          </section>
                          <section class='pl-3'>
                            <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                          </section>
                        </section>
                      </td>
                    </tr>
                  </template>

                  <template v-else>
                    <tr v-if="model.verificarGrupoBenzenoSeusCompostosToxicos(model.getGroup(legalSearch), legalSearch)" :key="`wp_chem_row4_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                      <td colspan="11" class="selectable-row">
                        <a href="#" @click="displayLegalInterpretation(legalSearch)">
                          <span class='selectable-row-text'>Agente necessita de interpretação jurídica selecione aqui</span>
                        </a>
                      </td>
                    </tr>
                    <tr v-else :key="`wp_chem_row3_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                      <td colspan="11" class="selectable-row">
                        <a href="#" @click="displayActivities(legalSearch, model.isActivitySpecific(legalSearch))">
                          <span class='selectable-row-text'>Agente necessita de determinação de atividade, selecione aqui</span>
                        </a>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </section>
        </section>

        <section v-if="agentWithoutProduct.riskType === 'fisico'">
          <section class='risk-physical d-flex align-items-center justify-content-center pt-3 pb-1 text-center w-100'>
            <h6><strong>Agentes pesquisados sem vínculo de produto ou cargo.</strong></h6>
          </section>

          <section class='risk-physical d-flex align-items-center margin-top-2 justify-content-between px-3 py-2'>
            <section>
              <strong class='risk-text'>Riscos Físicos</strong>
            </section>
            <section>
              <button class='btn-expand-collapse-navy-blue' @click="toggleChemicalExpanded('tabLtcatPhysicalRiskOpenAgentsWithoutProductAffiliation')">
                {{ userPreferences && userPreferences.tabLtcatPhysicalRiskOpenAgentsWithoutProductAffiliation ? 'Recolher informações' : 'Expandir informações' }}
              </button>
            </section>
          </section>

          <section class="margin-left-25">
            <table
              v-if="userPreferences && userPreferences.tabLtcatPhysicalRiskOpenAgentsWithoutProductAffiliation"
              class="text-center table b-table table-bordered custom-table margin-top-1"
            >
              <thead class="sticky">
                <tr class='header-table-physical'>
                  <th colspan="2" rowspan="2">CAS: Agente</th>
                  <th rowspan="2">Detalhes do agente</th>
                  <th rowspan="2">Limites de tolerância</th>
                  <th rowspan="2">Forma de avaliação</th>
                  <th rowspan="2">Relação com a NR 15</th>
                  <th colspan="2">Decreto 3048/99 - Anexo IV</th>
                  <th rowspan="2">Informações Previdenciárias Adicionais</th>
                  <th rowspan="2">ESOCIAL - Tabela 24</th>
                </tr>
                <tr class='header-table-physical'>
                  <th>Grupo</th>
                  <th>Código</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(legalSearch, indexLegalSearch) in agentWithoutProduct.legalSearches">
                  <template>
                    <tr :key="`wp_phys_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                      <td  :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                        <section class='px-2 no-wrap'>
                          <a v-if='importedCompany && importedCompany._id' class='word-break add-agent-prouct' @click="addAgentProduct(legalSearch)">
                            Adicionar agente <br/> ao cargo
                          </a>
                          <p v-else class='word-break'>-</p>
                        </section>
                      </td>
                      <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                        <a href="#" class='hover_links word-break' :id="`wp_phys_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                          <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                          <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                        </a>
                        <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                          <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                            <span>Ver orientações <br/> especificas</span>
                          </button>
                        </section>
                      </td>
                    </tr>
                  </template>

                  <template>
                    <tr :key='`wp_phys_row1_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                      <template v-for="field in model.tableFieldsPhysicalBiological">
                        <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                          <template v-if="field.key === 'group'">
                            <b-tooltip
                              v-if="getGroupLtcat(model.getGroup(legalSearch))"
                              :id="`sr_chem_group_$_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                              custom-class="custom-tooltip" placement="auto" triggers="hover"
                            >
                              <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                            </b-tooltip>
                            <a
                              class='hover_links'
                              href="#"
                              :id="`sr_chem_group_$_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                            >
                              <span>
                                {{ model.getGroup(legalSearch) }}
                                <b-icon
                                  v-if="getGroupLtcat(model.getGroup(legalSearch))"
                                  class='ml-1'
                                  font-scale="1.2"
                                  icon="info-circle-fill"
                                  variant="info">

                                </b-icon>
                              </span>
                            </a>
                          </template>
                          <template v-else>
                            <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, {}, {})"/>
                          </template>
                        </td>
                      </template>
                    </tr>

                    <tr :key='`wp_phys_row2_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                      <td colspan='8'>
                        <p class='title-observation'>
                          Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                          Ela não é uma conclusão de laudo técnico.
                        </p>
                        <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                          <section class='d-flex'>
                            <p class='observation transition'>
                              <span class='transition' v-html="model.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? model.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)"></span>
                              <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                                Clique para expandir ...
                              </strong>
                            </p>
                          </section>
                          <section class='pl-3'>
                            <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                          </section>
                        </section>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </section>
        </section>

        <section v-if="agentWithoutProduct.riskType === 'biologico'">
          <section class='risk-biological d-flex align-items-center justify-content-center pt-3 pb-1 text-center w-100'>
            <h6><strong>Agentes pesquisados sem vínculo de produto ou cargo.</strong></h6>
          </section>

          <section class='risk-biological d-flex align-items-center margin-top-2 justify-content-between px-3 py-2'>
            <section>
              <strong class='risk-text'>Riscos Biológicos</strong>
            </section>
            <section>
              <button class='btn-expand-collapse-navy-blue' @click="toggleChemicalExpanded('tabLtcatBiologicalRiskOpenAgentsWithoutProductAffiliation')">
                {{ userPreferences && userPreferences.tabLtcatBiologicalRiskOpenAgentsWithoutProductAffiliation ? 'Recolher informações' : 'Expandir informações' }}
              </button>
            </section>
          </section>

          <section class="margin-left-25">
            <table
              v-if="userPreferences && userPreferences.tabLtcatBiologicalRiskOpenAgentsWithoutProductAffiliation"
              class="text-center table b-table table-bordered custom-table margin-top-1"
            >
              <thead class="sticky">
                <tr class='header-table-biological'>
                  <th colspan="2" rowspan="2">CAS: Agente</th>
                  <th rowspan="2">Detalhes do agente</th>
                  <th rowspan="2">Limites de tolerância</th>
                  <th rowspan="2">Forma de avaliação</th>
                  <th rowspan="2">Relação com a NR 15</th>
                  <th colspan="2">Decreto 3048/99 - Anexo IV</th>
                  <th rowspan="2">Informações Previdenciárias Adicionais</th>
                  <th rowspan="2">ESOCIAL - Tabela 24</th>
                </tr>
                <tr class='header-table-biological'>
                  <th>Grupo</th>
                  <th>Código</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(legalSearch, indexLegalSearch) in agentWithoutProduct.legalSearches">
                  <template>
                    <tr :key="`wp_bio_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                      <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                        <section class='px-2 no-wrap'>
                          <a v-if='importedCompany && importedCompany._id' class='word-break add-agent-prouct' @click="addAgentProduct(legalSearch)">
                            Adicionar agente <br/> ao cargo
                          </a>
                          <p v-else class='word-break'>-</p>
                        </section>
                      </td>
                      <td :rowspan="model.getActivity(legalSearch) ? 3 : 2">
                        <a href="#" class='hover_links word-break' :id="`wp_bio_${agentWithoutProduct._id}_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`">
                          <span class='word-break'>{{ model.getsearchId(legalSearch) }}</span>
                          <b-icon style='margin-bottom: -1px' class='ml-1' font-scale="1.2" icon="info-circle-fill" variant="info"></b-icon>
                        </a>
                        <section v-if='legalSearch.videosOrientacaoAbaLtcat && legalSearch.videosOrientacaoAbaLtcat.length > 0'>
                          <button class='btn-orientations mt-2' @click='showModalOrientationVideos(model.getsearchId(legalSearch), legalSearch.videosOrientacaoAbaLtcat)'>
                            <span>Ver orientações <br/> especificas</span>
                          </button>
                        </section>
                      </td>
                    </tr>
                  </template>

                  <template>
                    <tr :key='`wp_bio_row1_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                      <template v-for="field in model.tableFieldsPhysicalBiological">
                        <td :key="`field_${field.key}`" :class="`field_${field.key}`">
                          <template v-if="field.key === 'group'">
                            <b-tooltip
                              v-if="getGroupLtcat(model.getGroup(legalSearch))"
                              :id="`sr_chem_group_$_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                              custom-class="custom-tooltip" placement="auto" triggers="hover"
                            >
                              <span class='text-white'>{{ getGroupLtcat(model.getGroup(legalSearch)) }}</span>
                            </b-tooltip>
                            <a
                              class='hover_links'
                              href="#"
                              :id="`sr_chem_group_$_${legalSearch.cas}_${legalSearch.legalSearchId}_${indexLegalSearch}`"
                            >
                              <span>
                                {{ model.getGroup(legalSearch) }}
                                <b-icon
                                  v-if="getGroupLtcat(model.getGroup(legalSearch))"
                                  class='ml-1'
                                  font-scale="1.2"
                                  icon="info-circle-fill"
                                  variant="info">

                                </b-icon>
                              </span>
                            </a>
                          </template>
                          <template v-else>
                            <span style='font-size: 15px !important;' v-html="model.getValue(field.key, legalSearch, {}, {})"/>
                          </template>
                        </td>
                      </template>
                    </tr>

                    <tr :key='`wp_bio_row2_${agentWithoutProduct._id}_${legalSearch.legalSearchId}_${indexLegalSearch}`'>
                      <td colspan='9'>
                        <p class='title-observation'>
                          Esta é uma frase de orientação para facilitar o seu entendimento durante a análise do enquadramento.
                          Ela não é uma conclusão de laudo técnico.
                        </p>
                        <section class='d-flex align-content-start justify-content-between py-4 px-3' style='background: #04A8F31A; border-radius: 6px'>
                          <section class='d-flex'>
                            <p class='observation transition'>
                              <span class='transition' v-html="model.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').substring(0, legalSearch.showCompleteObservationSentence ? model.getValue('ps', legalSearch, {}, {}).replaceAll(analysisPermanentExposureAndEffectiveProtection.textDefault(), '').length : 200)"></span>
                              <strong v-if='!legalSearch.showCompleteObservationSentence' class='pl-1 cursor-pointer text-expandir' @click="legalSearch.showCompleteObservationSentence = true">
                                Clique para expandir ...
                              </strong>
                            </p>
                          </section>
                          <section class='pl-3'>
                            <b-icon style='margin-top: -5px' class='ml-1 mr-1 transition cursor-pointer' :class="legalSearch.showCompleteObservationSentence ? 'rotate' : ''" font-scale="1.6" icon="chevron-down" @click="legalSearch.showCompleteObservationSentence = !legalSearch.showCompleteObservationSentence"></b-icon>
                          </section>
                        </section>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </section>
        </section>
      </section>

      <template v-slot:overlay>
        <div class="text-center loading-spinner">
          <b-spinner
            style="width: 2rem; height: 2rem"
            variant="primary"
            label="Large Spinner"
          ></b-spinner>
          <h4 class="text-primary">Buscando...</h4>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import Ltcat from '@/models/Ltcat'
import AnalysisPermanentExposureAndEffectiveProtection from '@/models/AnalysisPermanentExposureAndEffectiveProtection'
import LtcatModal from '@/components/LegalSearch/LtcatModal'
import LtcatLegalInterpretationModal from '@/components/LegalSearch/LtcatLegalInterpretationModal.vue'
import InsalubrityModal from '@/components/LegalSearch/InsalubrityModal'
import Taxonomy from '@/components/LegalSearch/components/Taxonomy'
import { mapActions, mapGetters } from 'vuex'
import eventBus from '../../utils/eventBus'
import TabButtons from '@/components/LegalSearch/components/TabButtons.vue'
import ProductAdd from '@/components/LegalSearch/Modal/ProductAdd.vue'
import OrientationVideos from '@/components/LegalSearch/Modal/OrientationVideos.vue'
import RoleLinkedModal from '@/components/LegalSearch/Modal/RoleLinkedModal.vue'
import ProductLinkedModal from '@/components/LegalSearch/Modal/ProductLinkedModal.vue'
import EffectiveProtection from '@/components/LegalSearch/Gro/components/EffectiveProtection.vue'
import PermanentExhibition from '@/components/LegalSearch/Gro/components/PermanentExhibition.vue'
import MeasurementsByRole from '@/components/LegalSearch/Modal/MeasurementsByRole.vue'
import EditTermsOfUsePerProduct from '@/components/LegalSearch/Modal/EditTermsOfUsePerProduct.vue'
import EditTemperaturePerProduct from '@/components/LegalSearch/Modal/EditTemperaturePerProduct.vue'
import AgentPercentage from '@/components/LegalSearch/Modal/AgentPercentage.vue'
import VentilationIdentifiedModal from '@/components/LegalSearch/Gro/components/TermsOfUse/VentilationIdentifiedModal.vue'
import Measurements from '@/components/LegalSearch/Gro/components/TermsOfUse/Measurements.vue'
import TemperatureModal from './Gro/components/TermsOfUse/TemperatureModal.vue'
import QuantityUsedFrequencyExposureTimeUseModal
  from './Gro/components/TermsOfUse/QuantityUsedFrequencyExposureTimeUseModal.vue'
import BindAgentToRolesModal from '@/components/LegalSearch/Summary/PhysicalRisk/Modal/BindAgentToRolesModal.vue'
import Role from '@/components/LegalSearch/Gro/components/Role.vue'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'
import ArchivedRoles from '@/components/LegalSearch/Gro/components/ArchivedRoles.vue'

export default {
  data() {
    return {
      generateImpression: false,
      allowed: true,
      loading: false,
      loadingLtcatModal: false,
      dontHavePlan: false,
      model: Ltcat,
      analysisPermanentExposureAndEffectiveProtection: AnalysisPermanentExposureAndEffectiveProtection,
      selectedAgent: {},
      protecaoEficazProps: null,
      exposicaoPermanenteProps: null,
      disabledAnalysisTool: false,
      productId: null,
      functionalityProps: 1,
      userOrProduct: null,
      scrollBarPosition: 0,
      orientationVideos: [],
      agent: '',
      benzenoSeusCompostosToxicos: `Benzeno e seus compostos tóxicos`.trim().toUpperCase(),
      casAgenteBenzeno: `71-43-2`,
      sectors: [],
      rolesHierarchy: [],
      productsLegalConsultation: [],
      agentsWithoutProduct: [],
      userPreferencesId: null,
      sectorsRoles: [],
      role: {},
      roleId: null,
      modalRef: null,
      productLegalConsultationId: null,
      productLegalConsultation: null,
      sectorRoleIds: [],
      productHierarchyIds: [],
      productsHierarchy: [],
      legalSearches: [],
      questions: [],
      sectorId: null,
      sectorRoleId: null,
      termsOfUseId: null,
      productHierarchyId: null,
      agentToBind: null,
      legalSearchId: null,
      tabName: 'LTCAT',
      titleArchive: '',
      descriptionArchive: '',
      loadingArchive: false,
      archiveSectorRoleId: null,
      archivedRolesSectorId: null,
    }
  },
  components: {
    OrientationVideos,
    ProductAdd,
    TabButtons,
    LtcatModal,
    InsalubrityModal,
    Taxonomy,
    LtcatLegalInterpretationModal,
    RoleLinkedModal,
    ProductLinkedModal,
    EffectiveProtection,
    PermanentExhibition,
    MeasurementsByRole,
    EditTermsOfUsePerProduct,
    EditTemperaturePerProduct,
    AgentPercentage,
    VentilationIdentifiedModal,
    Measurements,
    TemperatureModal,
    QuantityUsedFrequencyExposureTimeUseModal,
    BindAgentToRolesModal,
    Role,
    ModalConfirmAction,
    ArchivedRoles,
  },
  computed: {
    xlsxLink() {
      return `${process.env.VUE_APP_BASE_URL}/xlsx/${this.user.id}/ltcat`
    },
    summary() {
      return this.$store.getters['legalSearch/summary']
    },
    synergisticRiskProducts() {
      return this.$store.getters['legalSearch/synergisticRiskProducts']
    },
    user() {
      return this.$store.getters['user/current']
    },
    releaseAcgih() {
      return this.$store.getters['user/releaseAcgih']
    },
    summaryMeta() {
      return this.$store.getters['legalSearch/summaryMeta']
    },
    importedCompany() {
      return this.$store.getters['companyLegalConsultation/importedCompany']
    },
    ...mapGetters('rationaleGroups', {
      getGroupFundamentationLtcat: 'getGroupFundamentationLtcat',
      getGroupFundamentationUnhealthy: 'getGroupFundamentationUnhealthy'
    }),
    ...mapGetters('phraseListH', {
      getListOfPhrasesControlBanding: 'getListOfPhrasesControlBanding',
      getListOfPrecautionaryPhrasesControlBanding: 'getListOfPrecautionaryPhrasesControlBanding',
    }),
    ...mapGetters('permanentExhibition', {
      exposicaoPermanente: 'exposicaoPermanente',
    }),
    ...mapGetters('effectiveProtection', {
      protecaoEficaz: 'protecaoEficaz'
    }),
    ...mapGetters('userPreferences', {
      userPreferences: 'userPreferences',
    }),
  },
  methods: {
    ...mapActions('reportsDownloads', {
      handleCreateReportDownloads: 'handleCreateReportDownloads',
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb',
    }),
    ...mapActions('event', {
      handlGetEventActive: 'handlGetEventActive',
    }),
    ...mapActions('legalSearch', {
      exportingExcel: 'exportingExcel',
      setSlectedAgents: 'setSlectedAgents',
      handleGetAgentsWithoutProduct: 'handleGetAgentsWithoutProduct',
    }),
    ...mapActions('permanentExhibition', {
      handleCreatePermanentExhibition: 'handleCreatePermanentExhibition',
      handleUpdatePermanentExhibition: 'handleUpdatePermanentExhibition',
      handleGetPermanentExhibition: 'handleGetPermanentExhibition',
      handleGetByProductPermanentExhibition: 'handleGetByProductPermanentExhibition',
      handleGetByProductHierarchyPermanentExhibition: 'handleGetByProductHierarchyPermanentExhibition',
    }),
    ...mapActions('effectiveProtection', {
      handleCreateEffectiveprotection: 'handleCreateEffectiveprotection',
      handleUpdateEffectiveprotection: 'handleUpdateEffectiveprotection',
      handleGetEffectiveprotection: 'handleGetEffectiveprotection',
      handleGetByProductEffectiveprotection: 'handleGetByProductEffectiveprotection',
      handleGetEffectiveProtectionByRole: 'handleGetByRole',
      handleGetBySectorEffectiveprotection: 'handleGetBySectorEffectiveprotection',
      handleGetBySectorRoleEffectiveprotection: 'handleGetBySectorRoleEffectiveprotection',
    }),
    ...mapActions('userPreferences', {
      handleUpdateTabSummaryRiskOpen: 'handleUpdateTabSummaryRiskOpen',
      handleGetUserPreferences: 'handleGetUserPreferences',
    }),
    ...mapActions('role', {
      handleOpenRole: 'handleOpen',
      handleOpenRoleWithoutSector: 'handleOpenPreventionistLimits',
      handleUpdateRiskOpenSectorRole: 'handleUpdateRiskOpenSectorRole',
      handleUpdateRiskOpenRole: 'handleUpdateRiskOpenRole',
      handleArchiveSectorRole: 'handleArchive',
    }),
    ...mapActions('sector', {
      handleGetHierarchyByCompanyLegalConsultation: 'handleGetHierarchyByCompanyLegalConsultation',
      handleGetHierarchyByCompanyLegalConsultationNotLinkedSector: 'handleGetHierarchyByCompanyLegalConsultationNotLinkedSector',
      handleOpenSector: 'handleOpen',
    }),
    ...mapActions('product', {
      handlProductUpdateOpen: 'handleUpdateOpen',
    }),
    ...mapActions('productLegalConsultation', {
      productLegalConsultationGetWithoutRolesByCompany: 'productLegalConsultationGetWithoutRolesByCompany',
      handleUpdateOpenProductLegalConsultation: 'handleUpdateOpen',
    }),

    showModalOrientationVideos(agent, orientationVideos) {
      this.orientationVideos = orientationVideos
      this.agent = agent
      setTimeout(() => {
        this.$bvModal.show('orientationVideos')
      }, 100)
    },

    rowspan(legalConsultationAgentsGroupedByProduct, legalSearch) {
      if (!legalConsultationAgentsGroupedByProduct || legalConsultationAgentsGroupedByProduct._id === `-`) {
        return this.model.getActivity(legalSearch) ? 3 : 2
      }
      const notActivity = legalConsultationAgentsGroupedByProduct.legalSearches.filter((ls) => !this.model.getActivity(ls)).length
      return (legalConsultationAgentsGroupedByProduct.legalSearches.length * 3) - notActivity
    },

    async generateReport() {
      await this.exportingExcel(true)
      const payload = {
        user: this.user.id,
        type: 'ltcat',
        format: 'xlsx',
        job: 'legalConsultationReports',
        parameters: {}
      }
      const { data, status } = await this.handleCreateReportDownloads(payload)

      let message = data.message
      let variant = 'danger'
      await this.exportingExcel(false)
      if (status === 201) {
        message = data.message
        variant = 'success'
        this.$refs['alert'].show()
        return
      }
      this.$bvToast.toast(message, {
        title: 'Atenção',
        variant: variant,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000,
      })
    },

    displayActivities(item, isSpecific) {
      this.loadingLtcatModal = false
      this.selectedAgent = item
      if (isSpecific) {
        this.$bvModal.show('ltcat-modal')
      } else {
        this.$bvModal.show('activities-modal')
      }
      this.scrollBarPosition = document.documentElement.scrollTop
    },

    displayLegalInterpretation(item) {
      this.selectedAgent = item
      this.$bvModal.show('ltcat-legal-interpretation-modal')
      this.scrollBarPosition = document.documentElement.scrollTop
    },

    async saveSelectedActivities(agent) {
      this.loadingLtcatModal = true
      try {
        await this.$store.dispatch('legalSearch/saveActivities', agent)
        await this.load()
        this.loadingLtcatModal = false
        this.$bvModal.hide('activities-modal')
        window.scroll(0, this.scrollBarPosition)
        if (this.importedCompany && this.importedCompany._id) {
          this.$bvToast.toast(`As informações da empresa foram atualizadas.`, {
            title: 'Atenção',
            variant: 'success',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 6000,
          })
        }
      } catch (e) {
        this.loadingLtcatModal = false
        this.$bvToast.toast(`Não foi possível salvar as atividades. Tente novamente.`, {
          title: 'Erro',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 6000,
        })
      }
    },

    async load() {
      try {
        this.loading = true
        await this.setSlectedAgents([])
        await Promise.allSettled([
          this.loadTabSummaryRiskPreferences(),
          this.getSectorsByCompanyLegalConsultation(false),
          this.getRolesHierarchyByCompanyLegalConsultation(false),
          this.getProductLegalConsultationHierarchizedByCompany(),
          this.loadAgentsWithoutProduct(),
        ])
      } catch (e) {
        // silent
      } finally {
        this.loading = false
      }
    },

    async getSectorsByCompanyLegalConsultation(showLoading = true) {
      const { _id: companyLegalConsultationId } = this.importedCompany || {}
      if (companyLegalConsultationId) {
        if (showLoading) this.loading = true
        const { data: dataResponse } = (await this.handleGetHierarchyByCompanyLegalConsultation(companyLegalConsultationId)) || {}
        const { items } = dataResponse || {}
        this.sectors = items
        if (showLoading) this.loading = false
      }
    },

    async getRolesHierarchyByCompanyLegalConsultation(showLoading = true) {
      const { _id: companyLegalConsultationId } = this.importedCompany || {}
      if (companyLegalConsultationId) {
        if (showLoading) this.loading = true
        const { data: dataResponse } = (await this.handleGetHierarchyByCompanyLegalConsultationNotLinkedSector(companyLegalConsultationId)) || {}
        const { items } = dataResponse || {}
        this.rolesHierarchy = items || []
        if (showLoading) this.loading = false
      }
    },

    async reloadHierarchies() {
      this.loading = true
      await Promise.allSettled([
        this.getSectorsByCompanyLegalConsultation(false),
        this.getRolesHierarchyByCompanyLegalConsultation(false),
      ])
      this.loading = false
    },

    async toggleRoleOpen(roleItem) {
      try {
        if (!roleItem || !roleItem.role || !roleItem.role._id) return
        this.loading = true
        await this.handleOpenRoleWithoutSector(roleItem.role._id)
        await this.getRolesHierarchyByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loading = false
      }
    },

    async toggleRoleRiskOpen(roleItem, riskField) {
      try {
        if (!roleItem || !roleItem.role || !roleItem.role._id) return
        this.loading = true
        const newValue = !roleItem[riskField]
        this.$set(roleItem, riskField, newValue)
        await this.handleUpdateRiskOpenRole({
          _id: roleItem.role._id,
          [riskField]: newValue,
        })
        await this.getRolesHierarchyByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loading = false
      }
    },

    async toggleRoleProductOpen(product) {
      try {
        const { productLegalConsultationId, open } = product || {}
        if (!productLegalConsultationId) return
        this.loading = true
        await this.handleUpdateOpenProductLegalConsultation({ _id: productLegalConsultationId, open: !open })
        await this.getRolesHierarchyByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loading = false
      }
    },

    showModalArchivedRoles(sector, event) {
      event.stopPropagation()
      this.archivedRolesSectorId = sector._id
      setTimeout(() => {
        this.$bvModal.show('archivedRoles')
      }, 100)
    },

    showModalArchiveRole(sectorRole, sector, event) {
      event.stopPropagation()
      const { role, _id: sectorRoleId } = sectorRole
      this.archiveSectorRoleId = sectorRoleId
      this.titleArchive = 'Arquivar cargo'
      this.descriptionArchive = `${sector.unitName ? `<strong>Unidade:</strong> ${sector.unitName}<br/>` : ''}<strong>Setor:</strong> ${sector.name}<br/><br/>Essa ação vai arquivar o cargo <strong>${role.name}</strong> e as informações dele neste setor.<br/><br/>Ele deixará de ser mostrado nas abas GRO, Laudo de insalubridade, Limites prevencionistas, LTCAT e PCMSO. Você poderá desarquivá-lo depois.<br/><br/>Deseja realmente finalizar esta ação?`
      this.$bvModal.show('archiveRole')
    },

    async archiveRole() {
      try {
        this.loadingArchive = true
        const { data, status } = await this.handleArchiveSectorRole({ sectorRoleId: this.archiveSectorRoleId, tab: this.tabName })
        this.loadingArchive = false
        this.$bvModal.hide('archiveRole')
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        await this.getSectorsByCompanyLegalConsultation()
      } catch (e) {
        // silent
      }
    },

    async getProductLegalConsultationHierarchizedByCompany() {
      try {
        if (this.importedCompany && this.importedCompany._id) {
          const { data } = await this.productLegalConsultationGetWithoutRolesByCompany(this.importedCompany._id)
          const { items } = data || {}
          this.productsLegalConsultation = items || []
        } else {
          this.productsLegalConsultation = []
        }
      } catch (e) {
        // silent
      }
    },

    async loadAgentsWithoutProduct() {
      try {
        const { data } = await this.handleGetAgentsWithoutProduct(this.user.id)
        const { items } = data || {}
        this.agentsWithoutProduct = items || []
      } catch (e) {
        this.agentsWithoutProduct = []
      }
    },

    async loadTabSummaryRiskPreferences() {
      try {
        await this.handleGetUserPreferences(this.user.id)
        const { _id } = this.userPreferences || {}
        this.userPreferencesId = _id
      } catch (e) {
        // silent
      }
    },

    async toggleChemicalExpanded(field) {
      try {
        this.loading = true
        await this.handleUpdateTabSummaryRiskOpen({
          _id: this.userPreferencesId,
          [field]: !this.userPreferences[field]
        })
        await this.handleGetUserPreferences(this.user.id)
      } catch (e) {
        // silent
      } finally {
        this.loading = false
      }
    },

    async toggleRiskOpen(sectorRole, riskField) {
      try {
        if (!sectorRole || !sectorRole._id) return
        this.loading = true
        const newValue = !sectorRole[riskField]
        this.$set(sectorRole, riskField, newValue)
        await this.handleUpdateRiskOpenSectorRole({
          _id: sectorRole._id,
          [riskField]: newValue,
        })
        await this.getSectorsByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loading = false
      }
    },

    async toggleSectorOpen(sectorId) {
      try {
        this.loading = true
        await this.handleOpenSector(sectorId)
        await this.getSectorsByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loading = false
      }
    },

    async toggleSectorRoleOpen(sectorRoleId) {
      try {
        this.loading = true
        await this.handleOpenRole(sectorRoleId)
        await this.getSectorsByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loading = false
      }
    },

    async toggleProductOpen(product) {
      try {
        this.loading = true
        const { _id, open } = product || {}
        await this.handlProductUpdateOpen({ _id, open: !open })
        await this.getSectorsByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loading = false
      }
    },

    getRolesLegalsearches(sectorRole, risk) {
      const { role } = sectorRole || {}
      const { rolesLegalsearches } = role || {}
      if (!rolesLegalsearches || rolesLegalsearches.length <= 0) {
        return false
      }
      return rolesLegalsearches.filter(x => x.riskType == risk).length > 0
    },

    getAgentsByRisk(sectorRole, risk) {
      const { role } = sectorRole || {}
      const { rolesLegalsearches } = role || {}
      if (!rolesLegalsearches || rolesLegalsearches.length <= 0) {
        return []
      }
      return rolesLegalsearches.filter(x => x.riskType == risk)
    },

    async showModalAgentPercentage(product) {
      try {
        const { productLegalConsultationId: productId } = product || {}
        this.productId = productId
        setTimeout(() => {
          this.$bvModal.show('agentPercentage')
        }, 100)
      } catch (e) {
        // silent
      }
    },

    async showWorkersModal(product, modalRef) {
      try {
        const { productLegalConsultationId: productId, _id, termsofuses } = product || {}
        const { _id: termsOfUseId } = termsofuses || {}
        this.productId = productId
        this.productHierarchyId = _id
        this.termsOfUseId = termsOfUseId || null
        setTimeout(() => {
          this.$bvModal.show(modalRef)
        }, 100)
      } catch (e) {
        // silent
      }
    },

    async showModalCentilationWorkEnvironmentGeneral(sector, event) {
      try {
        event.stopPropagation()
        const { _id } = sector
        this.sectorId = _id
        setTimeout(() => {
          this.$bvModal.show('ventilationIdentifiedModal')
        }, 100)
      } catch (e) {
        // silent
      }
    },

    async setSelected(params) {
      this.sectorRoleIds = []
      const { sectorRoleIds } = params
      this.sectorRoleIds = sectorRoleIds
      this.$bvModal.hide('roleLinkedModal')
      const modalActions = {
        effectiveProtection: () => this.showEffectiveProtection(),
        measurementsByRole: () => this.showModalEditMeasurements()
      }
      const action = modalActions[this.modalRef]
      if (action) {
        await action()
      }
    },

    async setSelectedProductHierarchy(params) {
      this.sectorRoleIds = []
      const { productHierarchyIds } = params
      this.productHierarchyIds = productHierarchyIds
      this.$bvModal.hide('productLinkedModal')
      const modalActions = {
        editTermsOfUsePerProduct: () => this.$bvModal.show('editTermsOfUsePerProduct'),
        editTemperaturePerProduct: () => this.$bvModal.show('editTemperaturePerProduct'),
        agentPercentage: () => this.$bvModal.show('agentPercentage'),
      }
      const action = modalActions[this.modalRef]
      if (action) {
        setTimeout(async () => {
          await action()
        }, 100)
      }
    },

    async showEffectiveProtection(sectorId, sectorRoleId, event, questions) {
      if (event) event.stopPropagation()
      this.loading = true
      this.sectorId = sectorId
      this.sectorRoleId = sectorRoleId
      this.questions = questions
      if (sectorId) {
        const { effectiveProtection } = (await this.handleGetBySectorEffectiveprotection(this.sectorId)) || {}
        this.protecaoEficazProps = effectiveProtection
      } else if (sectorRoleId) {
        const { effectiveProtection } = (await this.handleGetBySectorRoleEffectiveprotection(this.sectorRoleId)) || {}
        this.protecaoEficazProps = effectiveProtection
      }
      this.loading = false
      setTimeout(() => {
        this.$bvModal.show('effectiveProtection')
      }, 100)
    },

    async updateEffectiveprotection(protecaoEficaz) {
      this.disabledAnalysisTool = true
      if (protecaoEficaz._id) {
        protecaoEficaz.tab = 'LTCAT'
        await this.handleUpdateEffectiveprotection(protecaoEficaz)
      } else {
        protecaoEficaz.tab = 'LTCAT'
        await this.handleCreateEffectiveprotection(protecaoEficaz)
        if (protecaoEficaz.sectorId) {
          const { effectiveProtection } = (await this.handleGetBySectorEffectiveprotection(this.sectorId)) || {}
          this.protecaoEficazProps = effectiveProtection
        } else if (protecaoEficaz.sectorRoleId) {
          const { effectiveProtection } = (await this.handleGetBySectorRoleEffectiveprotection(this.sectorRoleId)) || {}
          this.protecaoEficazProps = effectiveProtection
        }
      }
      this.disabledAnalysisTool = false
    },

    async showPermanentExhibition(product, sector, event) {
      try {
        if (event) event.stopPropagation()
        this.loading = true
        const { _id: productHierarchyId, productLegalConsultationId, termsofuses } = product || {}
        const { _id: termsOfUseId } = termsofuses || {}
        const { _id: sectorId } = sector || {}
        this.productHierarchyId = productHierarchyId
        this.productLegalConsultationId = productLegalConsultationId
        this.termsOfUseId = termsOfUseId || null
        this.sectorId = sectorId
        this.exposicaoPermanenteProps = null
        const { permanentExhibition } = (await this.handleGetByProductHierarchyPermanentExhibition({
          productHierarchyId,
          productLegalConsultationId,
          termsOfUseId,
          sectorId,
        })) || {}
        this.exposicaoPermanenteProps = permanentExhibition || null
      } catch (e) {
        // silent
      } finally {
        this.loading = false
        setTimeout(() => {
          this.$bvModal.show('permanent-exhibition')
        }, 100)
      }
    },

    async updatePermanentExhibition(exposicaoPermanente) {
      this.disabledAnalysisTool = true
      if (exposicaoPermanente._id) {
        exposicaoPermanente.tab = 'LTCAT'
        await this.handleUpdatePermanentExhibition(exposicaoPermanente)
      } else {
        exposicaoPermanente.user = this.user.id
        exposicaoPermanente.tab = 'LTCAT'
        exposicaoPermanente.productHierarchyId = this.productHierarchyId
        exposicaoPermanente.product = this.productHierarchyId
        await this.handleCreatePermanentExhibition(exposicaoPermanente)
      }
      const { permanentExhibition } = (await this.handleGetByProductHierarchyPermanentExhibition({
        productHierarchyId: this.productHierarchyId,
        productLegalConsultationId: this.productLegalConsultationId,
        termsOfUseId: this.termsOfUseId,
        sectorId: this.sectorId,
      })) || {}
      this.exposicaoPermanenteProps = permanentExhibition || null
      this.disabledAnalysisTool = false
    },

    async showModalEditMeasurements(sectorRole, event) {
      try {
        if (event) event.stopPropagation()
        this.sectorRoleId = sectorRole._id
        const { role } = sectorRole
        const { rolesProductsLegalConsultation } = role || {}
        this.legalSearches = []
        ;(rolesProductsLegalConsultation || []).forEach((x) => {
          if (x.product && x.product.legalSearches && x.product.legalSearches.length > 0) {
            const legalSearches = x.product.legalSearches.map((legalSearch, index) => {
              return {
                productId: x.productLegalConsultationId,
                productHierarchyId: x.product._id,
                legalSearch,
                _id: index + 1
              }
            })
            this.legalSearches.push(...legalSearches)
          }
        })
        setTimeout(() => {
          this.$bvModal.show('measurementsModal')
        }, 100)
      } catch (e) {
        // silent
      }
    },

    async saveSelectedActivitiesLtcat(agent) {
      this.loadingLtcatModal = true
      try {
        await this.$store.dispatch('legalSearch/saveActivities', agent)
        await this.load()
        this.loadingLtcatModal = false
        this.$bvModal.hide('ltcat-modal')
        window.scroll(0, this.scrollBarPosition)
        if (this.importedCompany && this.importedCompany._id) {
          this.$bvToast.toast(`As informações da empresa foram atualizadas.`, {
            title: 'Atenção',
            variant: 'success',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 6000,
          })
        }
      } catch (e) {
        this.loadingLtcatModal = false
        this.$bvToast.toast(`Não foi possível salvar as atividades. Tente novamente.`, {
          title: 'Erro',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 6000,
        })
      }
    },

    async saveInterpretationLtcat(agent) {
      await this.$store.dispatch('legalSearch/saveLegalInterpretation', agent)
      this.$bvModal.hide('ltcat-legal-interpretation-modal')
      await this.load()
      window.scroll(0, this.scrollBarPosition)
      if (this.importedCompany && this.importedCompany._id) {
        this.$bvToast.toast(`As informações da empresa foram atualizadas.`, {
          title: 'Atenção',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 6000,
        })
      }
    },

    getGroupLtcat(group) {
      const descriptionGroup = this.getGroupFundamentationLtcat.find((x) => x.group === group)
      return descriptionGroup ? descriptionGroup.reasoning : ''
    },

    getGroupUnhealthy(group) {
      const descriptionGroup = this.getGroupFundamentationUnhealthy.find((x) => x.group === group)
      return descriptionGroup ? descriptionGroup.reasoning : ''
    },

    getPhraseList(agent) {
      if (agent.controlBanding && agent.controlBanding.dangerPhrases && agent.controlBanding.dangerPhrases.length > 0) {
        let list = ``
        agent.controlBanding.dangerPhrases.forEach((x) => {
          this.getListOfPhrasesControlBanding.forEach((y) => {
            if (y[x]) {
              list += ` ${x}: <span class='mb-2'>${y[x]}</span><br/>`
            }
          })
        })
        return list
      }
      return `Não encontramos nenhuma frase de risco ou de nocividade para este agente, porém isso não quer dizer que ele não seja nocivo ou que não apresente riscos ao trabalhador. Trabalhamos constantemente buscando informações de agentes químicos e é possível que no futuro tenhamos mais informações sobre a nocividade deste agente químico. Recomendamos que seja analisada a FISPQ do produto que contém este agente e considere a nocividade ou riscos ao trabalhador conforme a FISPQ`
    },

    callGlobalCustomEvent(event) {
      eventBus.$emit(event)
    },

    addAAgentProduct(legalSearchId) {
      this.setSlectedAgents([legalSearchId])
      this.callGlobalCustomEvent('clearItems')
      this.$emit('select', legalSearchId)
      this.callGlobalCustomEvent('showModalAddProduct')
    },

    addAgentProduct(item) {
      const { legalSearchId } = item || {}
      this.legalSearchId = legalSearchId
      this.agentToBind = item || null
      this.$refs['add-agents-to-role'].show()
    },

    chooseAddToExistingRole() {
      this.$refs['add-agents-to-role'].hide()
      this.$nextTick(() => this.$refs.bindAgentToRolesModal.show())
    },

    chooseRegisterNewRole() {
      this.$refs['add-agents-to-role'].hide()
      this.$refs.role.init()
    },

    async onRoleCreated() {
      this.legalSearchId = null
      await this.reload()
    },

    async reload() {
      this.agentToBind = null
      await this.loadAgentsWithoutProduct()
      await this.getSectorsByCompanyLegalConsultation()
    },

    reset() {
      this.agentToBind = null
    },
  },
  async mounted() {
    try {
      eventBus.$on('generateReportLTCAT', async () => {
        await this.generateReport()
      })
      eventBus.$on('reloadLegalSearchReportTabs', async () => {
        await this.load()
      })
      await this.load()
      await this.handleGetPermanentExhibition(this.user.id)
      await this.handleGetEffectiveprotection(this.user.id)
      await this.handlGetEventActive()
    } catch (err) {
      this.loading = false
      this.dontHavePlan = false
      console.log(err)
    }
  },
  beforeDestroy() {
    eventBus.$off('generateReportLTCAT')
    eventBus.$off('reloadLegalSearchReportTabs')
  },
  created() {
    const breadcrumb = {
      tab: 'ltcat',
      page: 'Consulta Legal',
      subPage: {
        name: 'Consulta Legal',
        active: false
      },
      tabs: [
        {
          name: 'LTCAT',
          active: true
        }
      ]
    }
    this.setBreadcrumb(breadcrumb)
  },
}
</script>

<style>
.tooltip-inner {
  text-align: left;
  max-width: 400px !important;
  width: 400px !important;
}
</style>

<style lang='scss' scoped>
.margin-left-25{
  margin-left: 25px;
}
.risk-text {
  font-weight: 700;
  font-size: 16px;
  color: #262626;
}
.cargo-header {
  background: #BDEAFF;
  min-height: 60px;
}

.cargo-name {
  font-weight: 700;
  font-size: 16px;
  color: #262626;
}

.margin-top-1 {
  margin-top: 1px;
}

.risk-chemical {
  background: rgba(4, 168, 243, 0.4)!important;
  margin-top: 1px;
}

.risk-physical {
  background: #CCE5D2!important;
}

.risk-biological {
  background: #E3BEB0!important;
}



.btn-expand-collapse-navy-blue {
  background: transparent;
  border: 1px solid #022245;
  border-radius: 6.25px;
  font-weight: 600;
  padding: 10px;
}

.product {
  min-height: 60px;
  margin-top: 1px;
  margin-bottom: 1px;

  .name {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
  }

  .btn-options {
    border-radius: 5px !important;
    border: 2px solid var(--navy-blue);;
    background: transparent !important;
    width: 100px;
    text-align: center;
  }

  .options {
    border-radius: 8px !important;
    width: 290px !important;
  }

  .btn-options-text {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }

  .btn-product {
    border-radius: 5px !important;
    border: 2px solid var(--navy-blue);
    background: transparent;
    padding: 7px 5px;
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }

  .tr-title {
    font-weight: 600;
    font-size: 16px;
    color: #262626;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #EAEAEA;

    margin-left: 10px;
  }

  .table-agents {

  }
}

.btn-termsofuses {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1px solid #022245 !important;
  height: 48px !important;
  width: 48px !important;
  padding: 6px !important;

  svg {
    path {
      fill: var(--navy-blue) !important;
    }
  }
  .btn-icon{
    color: var(--navy-blue) !important;
  }
  &:hover {
    background: var(--navy-blue) !important;

    svg {
      path {
        fill: #FFFFFF !important;
      }
    }
  }
}

.cargo-agents-table {
  width: calc(100% - 2rem);
}

.transition {
  transition: all 0.3s ease;
}

.rotate {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}

.transition {
  color: var(--navy-blue);
  -webkit-transition: -webkit-transform 0.5s ease-in-out;
  -ms-transition: -ms-transform 0.5s ease-in-out;
  transition: transform 0.5s ease-in-out;
}

.text-expandir {
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  text-decoration: underline;
  color: #04A8F3;
}

.hover_links {
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 24px;
  color: #04A8F3;
}

.sticky {
  position: sticky;
  top: 10px;
  z-index: 10;
}

.container-tab-buttons {
  padding: 0 0 5px 0 !important;
}

.headerTable {
  vertical-align: middle;
  background: #DADADA;
}
.headerTable th {
  background: #DADADA!important;
}
.header-table-chemical {
  vertical-align: middle;
  background: #04A8F366!important;
}
.header-table-chemical th {
  vertical-align: middle;
  background: #04A8F366!important;
}
.header-table-physical {
  vertical-align: middle;
  background: #CCE5D2;
}
.header-table-physical th {
  vertical-align: middle;
  background: #CCE5D2!important;
  border: 1px solid #EDEDED;
}

.header-table-biological {
  vertical-align: middle;
  background: #E3BEB0!important;
}
.header-table-biological th {
  vertical-align: middle;
  background: #E3BEB0!important;
  border: 1px solid #EDEDED;
}

.width-10-percent {
  width: 10% !important;
}

.min-width-160-px {
  min-width: 160px !important;
}

.width-20-percent {
  width: 20% !important;
}
.width-30-percent {
  width: 20% !important;
}

.imprimir {
  color: var(--blue);
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
}

.imprimir:hover {
  text-decoration: underline
}

.loading {
  width: 1.5rem;
  height: 1.5rem;
}

.selectable-row {
  vertical-align: middle;
  background: rgba(4, 168, 243, 0.1)
}

.selectable-row-text {
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  color: #022245 !important;
}

td {
  vertical-align: middle;
}

.field_ps {
  text-align: left;
  font-size: 12px;
}

.title-observation {
  color: #262626;
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 10px !important;
  font-weight: bold;
  text-align: center;
}

.observation {
  font-size: 14px;
  line-height: 1.2;
  margin: -5px !important;
  text-align: left;
  padding-left: 10px;
}

.btn-filled-analysis-tools {
  border: 1px solid #022245;
  background: transparent !important;
  padding: 2px;
  border-radius: 3px;
}

.btn-unpopulated-analysis-tools {
  border: 1px solid #FF0000;
  background: transparent !important;
  padding: 2px;
  border-radius: 3px;
}

.btn-synergistic-risk {
  width: 32px !important;
  height: 32px !important;
  background: #CBD63E !important;
  border: 1px solid #022245;
  border-radius: 2px;
}

.phrases {
  list-style: inside;
  margin-left: 20px;

  li {
    list-style-position: outside;
  }
}

.margin-top-2 {
  margin-top: 2px;
}

.btn-sector-effectiveProtection-information-filled-in {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: px solid var(--navy-blue) !important;
  height: 48px !important;
  width: 48px !important;
  padding: 6px !important;
  svg {
    path {
      stroke: var(--navy-blue) !important;
    }
  }
  &:hover {
    background: var(--navy-blue) !important;

    svg {
      path {
        stroke: #FFFFFF !important;
      }
    }
  }
}

.btn-sector-effectiveProtection-information-not-filled-in {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1px solid #CD0000!important;
  height: 48px !important;
  width: 48px !important;
  padding: 6px !important;
  svg {
    path {
      stroke: #CD0000 !important;
    }
  }
  &:hover {
    background: #CD0000 !important;

    svg {
      path {
        stroke: #FFFFFF !important;
      }
    }
  }
}

.btn-information-filled-in {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1px solid #022245 !important;
  height: 48px !important;
  width: 48px !important;
  padding: 6px !important;

  svg {
    path {
      fill: var(--navy-blue) !important;
    }
  }
  .btn-icon{
    color: var(--navy-blue) !important;
  }
  &:hover {
    background: var(--navy-blue) !important;

    svg {
      path {
        fill: #FFFFFF !important;
      }
    }
  }
}
.btn-information-not-filled-in {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1px solid #CD0000 !important;
  height: 48px !important;
  width: 48px !important;
  padding: 6px !important;

  svg {
    path {
      fill:  #CD0000 !important;
    }
  }
  .btn-icon{
    color:  #CD0000 !important;
  }
  &:hover {
    background:  #CD0000 !important;

    svg {
      path {
        fill: #FFFFFF !important;
      }
    }
  }
}

.btn-completed-permanent-exhibition {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1.5px solid #022245 !important;
  height: 48px !important;
  width: 48px !important;
  padding: 6px !important;
  text-align: center;
  .image-permanent-exhibition {
    background-image: url("../../assets/images/protecaoEficazAzul.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 30px;
    height: 30px !important;
    width: 30px !important;
    margin-bottom: 0;
  }
  &:hover {
    background: #022245 !important;
    .image-permanent-exhibition {
      background-image: url("../../assets/images/protecaoEficazBranco.svg");
    }
  }
}

.btn-permanent-exhibition-without-filling {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1.5px solid #CD0000 !important;
  height: 48px !important;
  width: 48px !important;
  padding: 6px !important;
  text-align: center;
  .image-permanent-exhibition {
    background-image: url("../../assets/images/protecaoEficazVermelho.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 30px;
    height: 30px !important;
    width: 30px !important;
    margin-bottom: 0;
  }
  &:hover {
    background: #CD0000 !important;
    .image-permanent-exhibition {
      background-image: url("../../assets/images/protecaoEficazBranco.svg");
    }
  }
}

.sector {
  background: #04A8F3 !important;
  //margin-left: 50px !important;
  margin-top: 1px !important;
  min-height: 60px !important;
  cursor: pointer !important;

  .name {
    color: #FFFFFF !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    text-align: center !important;
  }

  .btn-options {
    border-radius: 5px !important;
    border: 2px solid #FFFFFF !important;
    background: transparent !important;
    width: 100px !important;
    text-align: center !important;
  }

  .options {
    border-radius: 8px !important;
    width: 220px !important;
  }

  .btn-options-text {
    color: #FFFFFF !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
  }
}
</style>
